/* ================================================================
       8TH DIMENSION — PLAYER / CART ENGINE · v4.1
       v4.1 changes: no auto-play (paused init, play on user gesture only),
       metaobject-driven track metadata + album artwork, dynamic beat count,
       and cart quantity steppers with live totals.
    ================================================================ */
    /* ================================================================
       BRAND DATA
    ================================================================ */
    const FALLBACK_BEATS = [
  { n:1, name:'Dark Nights',      genre:'Trap',     mood:'Dark',      bpm:140, key:'Am', dur:'3:42', sec:222, price:29,  tags:['Trap','Dark','Cinematic'], tc:'rt-1' },
  { n:2, name:'Midnight Rider',   genre:'Hip-Hop',  mood:'Smooth',    bpm: 92, key:'Gm', dur:'2:58', sec:178, price:29,  tags:['Hip-Hop','Smooth'],        tc:'rt-2' },
  { n:3, name:'Savage Season',    genre:'Trap',     mood:'Hard',      bpm:145, key:'Dm', dur:'3:15', sec:195, price:34,  tags:['Trap','Hard','808'],        tc:'rt-3' },
  { n:4, name:'Gold Rush',        genre:'R&B',      mood:'Melodic',   bpm: 80, key:'Em', dur:'4:02', sec:242, tags:['R&B','Melodic'], tc:'rt-4' },
  { n:5, name:'Concrete Jungle',  genre:'Hip-Hop',  mood:'Street',    bpm: 88, key:'Cm', dur:'3:30', sec:210, tags:['Hip-Hop','Street'], tc:'rt-5' },
  { n:6, name:'Phantom Flex',     genre:'Drill',    mood:'Dark',      bpm:144, key:'Bm', dur:'3:18', sec:198, tags:['Drill','UK','Dark'], tc:'rt-6' },
  { n:7, name:'Signal Protocol',  genre:'Trap',     mood:'Cinematic', bpm:138, key:'F#m',dur:'4:10', sec:250, tags:['Trap','Cinematic','Epic'], tc:'rt-7' },
  { n:8, name:'Void Walker',      genre:'Dark',     mood:'Moody',     bpm: 76, key:'Dm', dur:'5:02', sec:302, tags:['Dark','Ambient','Moody'], tc:'rt-8' },
];
const BEATS = Array.isArray(window.JREDD_BEATS) && window.JREDD_BEATS.length ? window.JREDD_BEATS : FALLBACK_BEATS;
const LICENSES = Array.isArray(window.JREDD_LICENSES) && window.JREDD_LICENSES.length ? window.JREDD_LICENSES : [
  { key:'lease',     label:'Lease',     price:49,   desc:'MP3 + WAV' },
  { key:'premium',   label:'Premium',   price:149,  desc:'MP3 + WAV + Stems' },
  { key:'exclusive', label:'Exclusive', price:null, desc:'Full stems + pre-master · Inquire' },
];
    const fmtPrice = p => {
      if (p === null || p === undefined) return 'Inquire';
      const n = Number(p);
      return Number.isFinite(n) ? `$${n.toFixed(2)}` : `$${p}`;
    };
const previewAudio = new Audio();
previewAudio.preload = 'metadata';
previewAudio.addEventListener('ended', () => {
  progress = 0;
  activeIdx = (activeIdx + 1) % BEATS.length;
  activeLicense = 0;
  refreshAll(true);
  setPlaying(true);
});
function currentPreviewUrl() {
  return BEATS[activeIdx]?.previewUrl || BEATS[activeIdx]?.audio || '';
}
function syncPreviewAudio() {
  const src = currentPreviewUrl();
  if (!src) return;
  if (previewAudio.src !== src) previewAudio.src = src;
  const b = BEATS[activeIdx];
  if (b?.sec && Number.isFinite(b.sec)) {
    const desired = Math.max(0, Math.min(b.sec - 0.25, (progress / 100) * b.sec));
    if (Math.abs(previewAudio.currentTime - desired) > 1.5) previewAudio.currentTime = desired;
  }
}
function selectedVariantId(beatIdx, licenseKey) {
  const variants = BEATS[beatIdx]?.variants || {};
  return variants[licenseKey] || variants[licenseKey?.toLowerCase?.()] || null;
}
async function addVariantToShopifyCart(beatIdx, licenseKey) {
  const variantId = selectedVariantId(beatIdx, licenseKey);
  if (!variantId) return { skipped: true };
  const response = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  });
  if (!response.ok) throw new Error('Shopify cart add failed');
  return response.json();
}

    const BPM_RANGES = [
      { label:'< 90',     test: b => b.bpm < 90 },
      { label:'90–110',   test: b => b.bpm >= 90 && b.bpm <= 110 },
      { label:'110–130',  test: b => b.bpm > 110 && b.bpm <= 130 },
      { label:'130–150',  test: b => b.bpm > 130 && b.bpm <= 150 },
      { label:'> 150',    test: b => b.bpm > 150 },
    ];

    // v2.18: nav now scroll-anchors to in-page sections (no more JS modal).
    const NAV_ITEMS = [
      { label:'HOME',            sub:'Catalog',     target:'#shopify-section-hero',     icon:`<svg viewBox="0 0 24 24"><path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/></svg>` },
      { label:'LICENSING',       sub:'Tiers',       target:'#shopify-section-licensing',icon:`<svg viewBox="0 0 24 24"><path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z"/></svg>` },
      { label:'BIO',             sub:'About',       target:'#shopify-section-bio',      icon:`<svg viewBox="0 0 24 24"><path d="M12 12c2.7 0 5-2.3 5-5s-2.3-5-5-5-5 2.3-5 5 2.3 5 5 5zm0 2c-3.3 0-10 1.7-10 5v2h20v-2c0-3.3-6.7-5-10-5z"/></svg>` },
      { label:'CONTACT',         sub:'Work With Me',target:'#shopify-section-contact',  icon:`<svg viewBox="0 0 24 24"><path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/></svg>` },
    ];

    /* ================================================================
       WAVEFORM DATA (deterministic per beat)
    ================================================================ */
    const WF_COUNT = 40;
    const BEAT_WAVES = BEATS.map((_,ti) =>
      Array.from({length:WF_COUNT},(_,i) => {
        const s = (ti*1000+i*73)%100;
        return 12+((s*31+17)%72);
      })
    );

    /* ================================================================
       STATE
    ================================================================ */
    let activeIdx     = 0;
    let isPlaying     = false;
    let progress      = 0;
    let tickId        = null;
    let activeNav     = 0;
    let activeLicense = 0;

    // Filters & search
    const filters = { genre:null, mood:null, key:null, bpm:null };
    let searchQuery = '';
    let visibleBeats = BEATS.slice();
    let openFilterMenu = null; // { filter, el }

    // Cart
    let cart = []; // [{ beatIdx, licenseKey }]

    // Modal
    let modalOpen = null; // 'purchase' | 'bio' | 'contact' | null

    /* ================================================================
       LOADING SEQUENCE
    ================================================================ */
    const LOAD_MSGS = [
      'INITIALIZING BEAT SYSTEM',
      'LOADING AUDIO ENGINE',
      'SCANNING CATALOG',
      'CALIBRATING WAVEFORMS',
      'SIGNAL ACQUIRED',
    ];
    let loadPct = 0;
    const loadFill   = document.getElementById('loadFill');
    const loadStatus = document.getElementById('loadStatus');
    const loadScreen = document.getElementById('loading');

    // Inject the J.REDD wordmark SVG into the loading screen immediately
    (function injectLoadingLogoNow(){
      const src = document.querySelector('.logo-svg-wrap svg');
      const tgt = document.getElementById('loadingLogo');
      if (src && tgt && !tgt.firstChild) tgt.appendChild(src.cloneNode(true));
    })();

    // Background hero video — play at 30% speed, muted, looped, autoplay.
    // We set playbackRate after metadata loads (some browsers reset it on src load).
    (function initBgVideo(){
      const v = document.getElementById('bgMediaEl');
      if (!v || v.tagName !== 'VIDEO') return;
      const SPEED = 0.3;
      const apply = () => { try { v.playbackRate = SPEED; } catch(e){} };
      v.addEventListener('loadedmetadata', apply);
      v.addEventListener('play', apply);
      v.addEventListener('ratechange', () => {
        // Re-clamp if the browser tries to reset us
        if (Math.abs(v.playbackRate - SPEED) > 0.01) apply();
      });
      // Ensure autoplay survives strict policies
      const tryPlay = () => v.play().catch(() => {});
      tryPlay();
      document.addEventListener('visibilitychange', () => { if (!document.hidden) tryPlay(); });
      apply();
    })();

    // v4.6: null-guarded — the /cart compatibility bridge page has no loading
    // screen (it redirects immediately), so bail out quietly if it's absent.
    const loadTimer = (loadFill && loadStatus && loadScreen) ? setInterval(() => {
      loadPct += Math.random()*20+10;
      if (loadPct>100) loadPct=100;
      loadFill.style.width = loadPct+'%';
      loadStatus.textContent = LOAD_MSGS[Math.min(Math.floor(loadPct/22),LOAD_MSGS.length-1)];
      if (loadPct>=100) {
        clearInterval(loadTimer);
        setTimeout(() => { loadScreen.classList.add('hidden'); boot(); }, 700);
      }
    }, 250) : null;

    /* ================================================================
       BOOT
    ================================================================ */
    function boot() {
      applyFilters();
      renderBeatList();
      renderFeaturedBeat();
      renderWaveform();
      renderLicensing();
      renderNav();
      renderCart();
      spawnParticles();
      attachExtraHandlers();
      // v2.18 additions
      initStickyPlayer();
      hydrateCartFromStorage();
      // v4.8: reconcile the hydrated cache against Shopify (/cart.js is the
      // single source of truth). Async — the cached render above is instant,
      // and is only re-rendered if Shopify disagrees (no flicker when equal).
      reconcileCartState();
      updateStickyBar(BEATS[activeIdx]);
      initV18Extras();
      initV18Modals(); // v2.18: Privacy + License Terms modals
      // v2.21: cookie consent system. Init must run AFTER initV18Modals so
      // the cookie-prefs modal trigger works, and AFTER the banner is in the
      // DOM (it's static markup, present at boot).
      v21WireBanner();
      v21InitConsent();
      // v4.1: NO auto-play. All tracks initialize paused; playback begins only
      // when the user clicks Preview/Play. Sync the transport UI to the paused
      // state without starting audio (avoids autoplay-policy console warnings).
      isPlaying = false;
      updatePreviewButton();
      setStickyPlaying(false);
      syncEqPause();
    }

    /* ================================================================
       FEATURED BEAT PANEL
    ================================================================ */
    function renderFeaturedBeat(animate) {
      const b = BEATS[activeIdx];
      document.getElementById('beatEyebrow').textContent = 'J.REDD PRODUCTION CATALOG';

      // v2.18: pricing removed pending per-beat pricing. Just set the title.
      document.getElementById('beatTitle').textContent = b.name;

      document.getElementById('beatStats').innerHTML =
        `${b.genre} &nbsp;<em>·</em>&nbsp; ${b.bpm} BPM &nbsp;<em>·</em>&nbsp; ${b.key} &nbsp;<em>·</em>&nbsp; ${b.dur}`;
      document.getElementById('timeDuration').textContent = b.dur;

      const tagsEl = document.getElementById('beatTagsEl');
      tagsEl.innerHTML = b.tags.map((t,i)=>
        `<span class="beat-tag${i===0?'':' neutral'}">${t}</span>`
      ).join('');

      renderArtwork(b, animate);

      // Mini player in modal (legacy — still present, harmless)
      const miniArt = document.getElementById('miniArt');
      if (miniArt) {
        miniArt.className = 'mini-art ' + b.tc + (b.artwork ? ' has-img' : '');
        if (b.artwork) {
          miniArt.innerHTML = `<img src="${b.artwork}" alt="" loading="lazy" decoding="async">`;
        } else {
          miniArt.textContent = String(b.n).padStart(2,'0');
        }
        document.getElementById('miniName').textContent = b.name;
        document.getElementById('miniSub').textContent  = `${b.genre} · ${b.bpm} BPM`;
      }

      // Update prices
      updateCartPrice();
      updateBuyTriggerPrice();

      // v2.18: sync sticky bar
      updateStickyBar(b);
    }

    /* Per-track artwork (v4.1): when the beat's linked metaobject supplies an
       album image (b.artwork), render it inside the player; otherwise fall back
       to the gradient tile + track-number glyph. The swap-in / swap-out classes
       drive the existing smooth crossfade so the transition stays native to the
       current UI aesthetic. */
    function renderArtwork(b, animate) {
      const inner = document.getElementById('beatArtInner');
      // Reset inner background gradient based on b.tc by using thumb class
      inner.className = 'beat-art__inner ' + b.tc;
      const face = b.artwork
        ? `<img class="beat-art__img" src="${b.artwork}" alt="${(b.name || 'Beat')} artwork" loading="lazy" decoding="async">`
        : `<span class="art-glyph">${String(b.n).padStart(2,'0')}</span>`;
      const html = `<div class="beat-art__art${animate ? ' swap-in' : ''}${b.artwork ? ' has-img' : ''}">
        ${face}
      </div>`;
      // Animate swap
      if (animate && inner.firstChild) {
        const old = inner.querySelector('.beat-art__art');
        if (old) old.classList.add('swap-out');
        setTimeout(()=>{ inner.innerHTML = html; }, 220);
      } else {
        inner.innerHTML = html;
      }
    }

    /* ================================================================
       WAVEFORM
    ================================================================ */
    function renderWaveform() {
      const bars = document.getElementById('waveformBars');
      const wave = BEAT_WAVES[activeIdx];
      const playedCount = Math.round((progress/100)*WF_COUNT);

      bars.innerHTML = wave.map((h,i) => {
        const played = i < playedCount;
        return `<div class="wf-bar ${played?'played':'unplayed'}" style="height:${h}%" data-i="${i}"></div>`;
      }).join('');

      // Waveform seek
      bars.querySelectorAll('.wf-bar').forEach(bar => {
        bar.addEventListener('click', e => {
          const i = +bar.dataset.i;
          progress = (i/WF_COUNT)*100;
          resetTicker();
          renderWaveform();
          updateProgressUI();
        });
      });

      // Playhead
      document.getElementById('waveformPlayhead').style.left = progress+'%';
    }

    function updateWaveHighlight() {
      const playedCount = Math.round((progress/100)*WF_COUNT);
      document.querySelectorAll('#waveformBars .wf-bar').forEach((bar,i) => {
        bar.classList.toggle('played',   i < playedCount);
        bar.classList.toggle('unplayed', i >= playedCount);
      });
      document.getElementById('waveformPlayhead').style.left = progress+'%';
    }

    /* ================================================================
       LICENSING
    ================================================================ */
    function renderLicensing() {
      const el = document.getElementById('licensingEl');
      // v2.19: prices restored. Exclusive shows "Inquire" instead of a $ amount.
      el.innerHTML = LICENSES.map((l,i) => `
        <div class="license-tier${i===activeLicense?' selected':''}" data-li="${i}">
          <div class="lt__label">${l.label}</div>
          <div class="lt__price${l.price===null?' inquire':''}">${fmtPrice(l.price)}</div>
          <div class="lt__type">${l.desc}</div>
        </div>
      `).join('');
      el.querySelectorAll('.license-tier').forEach(t => {
        t.addEventListener('click',() => {
          activeLicense = +t.dataset.li;
          renderLicensing();
          updateCartPrice();
          updateBuyTriggerPrice();
        });
      });
    }

    // v2.19: BUY trigger + ADD TO CART labels reflect the currently-selected tier.
    function updateCartPrice() {
      const el = document.getElementById('cartPriceLabel');
      if (!el) return;
      const lic = LICENSES[activeLicense];
      el.textContent = lic.price === null ? 'INQUIRE' : `— ${fmtPrice(lic.price)}`;
    }
    function updateBuyTriggerPrice() {
      const el = document.getElementById('buyTriggerLabel');
      if (!el) return;
      const lic = LICENSES[activeLicense];
      el.textContent = lic.price === null ? 'Inquire — Exclusive' : `License — ${fmtPrice(lic.price)}`;
    }

    /* ================================================================
       BEAT LIST
    ================================================================ */
    function renderBeatList() {
      const list = document.getElementById('beatList');
      // v4.1: reflect the real number of beats loaded into the player.
      const countEl = document.getElementById('beatListCount');
      if (countEl) countEl.textContent = BEATS.length;
      if (!visibleBeats.length) {
        list.innerHTML = `<div class="filter-empty">No beats match your <span>filters</span>.</div>`;
        return;
      }
      list.innerHTML = visibleBeats.map((b) => {
        const i = BEATS.indexOf(b);
        const isActive = i===activeIdx;
        const wave     = BEAT_WAVES[i];
        const playedN  = isActive ? Math.round((progress/100)*12) : 0;
        const waveHTML = wave.slice(0,12).map((h,wi) =>
          `<div class="row-wave-seg${isActive&&wi<playedN?' played':''}" style="height:${h}%"></div>`
        ).join('');

        return `<div class="beat-row${isActive?' active':''}" data-index="${i}" role="listitem" tabindex="0" aria-label="${b.name}, ${b.genre}, ${b.bpm} BPM">
          <div class="row-num-wrap">
            <span class="row-num">${b.n}</span>
            <div class="row-eq" aria-hidden="true">
              <div class="eq-bar"></div><div class="eq-bar"></div>
              <div class="eq-bar"></div><div class="eq-bar"></div>
            </div>
          </div>
          <div class="row-thumb ${b.tc}${b.artwork ? ' has-img' : ''}">
            ${b.artwork
              ? `<img class="row-thumb__img" src="${b.artwork}" alt="" loading="lazy" decoding="async">`
              : `<div class="row-thumb__inner">${String(b.n).padStart(2,'0')}</div>`}
          </div>
          <div class="row-info">
            <div class="row-name">${b.name}</div>
            <div class="row-meta">${b.bpm} BPM &nbsp;·&nbsp; ${b.key}</div>
          </div>
          <span class="row-genre">${b.genre}</span>
          <div class="row-wave">${waveHTML}</div>
          <button class="row-buy" data-index="${i}" aria-label="License ${b.name}">LICENSE</button>
        </div>`;
      }).join('');

      list.querySelectorAll('.beat-row').forEach(el => {
        el.addEventListener('click', e => {
          if(e.target.classList.contains('row-buy')) return;
          const idx = +el.dataset.index;
          if(idx===activeIdx) { togglePlay(); return; }
          jumpTo(idx);
        });
        el.addEventListener('keydown', e => {
          if(e.key==='Enter'||e.key===' ') { e.preventDefault(); jumpTo(+el.dataset.index); }
        });
        el.querySelector('.row-buy').addEventListener('click', e => {
          e.stopPropagation();
          const idx = +e.currentTarget.dataset.index;
          addToCart(idx, 'lease'); // v2.19: default tier renamed
        });
      });

      syncEqPause();
    }

    function syncEqPause() {
      document.getElementById('beatList').classList.toggle('paused',!isPlaying);
      document.getElementById('beatArt').classList.toggle('playing',isPlaying);
    }

    /* ================================================================
       PLAYBACK
    ================================================================ */
    // v4.1: switching tracks preserves the current transport state. A paused
    // player stays paused on select/prev/next; only an already-playing player
    // continues into the newly selected beat. Playback otherwise starts solely
    // from the Preview/Play button.
    function jumpTo(idx) {
      const wasPlaying = isPlaying;
      activeIdx=idx; progress=0; activeLicense=0;
      previewAudio.pause(); previewAudio.removeAttribute('src');
      refreshAll(true); collapsePurchase();
      setPlaying(wasPlaying);
    }
    function togglePlay(){ setPlaying(!isPlaying); }

    function refreshAll(animateArt) {
      renderFeaturedBeat(animateArt);
      renderWaveform();
      renderLicensing();
      renderBeatList();
    }

    function setPlaying(state) {
      isPlaying=state;
      setStickyPlaying(state); // v2.18: keep sticky bar play-icon in sync
      updatePreviewButton();
      syncEqPause();
      if(isPlaying) { syncPreviewAudio(); previewAudio.play().catch(()=>{}); resetTicker(); } else { clearInterval(tickId); previewAudio.pause(); }
    }

    function resetTicker() {
      clearInterval(tickId);
      const b=BEATS[activeIdx], intv=80;
      const total=(b.sec*1000)/intv;
      let tick=Math.floor((progress/100)*total);

      tickId=setInterval(()=>{
        if(!isPlaying) return;
        tick++;
        progress=(tick/total)*100;
        if(progress>=100){
          clearInterval(tickId);
          progress=0;
          activeIdx=(activeIdx+1)%BEATS.length;
          activeLicense=0;
          refreshAll();
          setPlaying(true);
          return;
        }
        updateProgressUI();
        updateWaveHighlight();
        // Update list row wave occasionally
        if(tick%30===0) renderBeatList();
      },intv);
    }

    function updatePreviewButton(){
      const icon=document.getElementById('previewIcon');
      const lbl=document.getElementById('previewLabel');
      if(isPlaying){ icon.innerHTML='<path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"/>'; lbl.textContent='PAUSE'; }
      else         { icon.innerHTML='<path d="M8 5v14l11-7z"/>'; lbl.textContent='PREVIEW'; }
      // Sync mini-player icon (if present)
      const m=document.getElementById('miniPlayIcon');
      if(m) m.innerHTML = isPlaying
        ? '<path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"/>'
        : '<path d="M8 5v14l11-7z"/>';
    }

    function updateProgressUI(){
      const b=BEATS[activeIdx];
      const fill=document.getElementById('waveformPlayhead');
      fill.style.left=progress+'%';
      const el=Math.floor(b.sec*progress/100);
      const m=Math.floor(el/60),s=el%60;
      document.getElementById('timeElapsed').textContent=`${m}:${s.toString().padStart(2,'0')}`;
    }

    /* ================================================================
       HEADER CONTROLS
    ================================================================ */
    document.getElementById('btnPreview').addEventListener('click',togglePlay);
    document.getElementById('btnPrev').addEventListener('click',()=>{
      jumpTo((activeIdx-1+BEATS.length)%BEATS.length);
    });
    document.getElementById('btnNext').addEventListener('click',()=>{
      jumpTo((activeIdx+1)%BEATS.length);
    });

    /* ================================================================
       WAVEFORM CONTAINER SEEK
    ================================================================ */
    document.getElementById('waveformContainer').addEventListener('click',e=>{
      const rect=e.currentTarget.getBoundingClientRect();
      progress=Math.max(0,Math.min(100,((e.clientX-rect.left)/rect.width)*100));
      if(!isPlaying) setPlaying(true); else { syncPreviewAudio(); resetTicker(); }
      updateProgressUI();
      updateWaveHighlight();
    });

    /* ================================================================
       BOTTOM NAV
    ================================================================ */
    function renderNav(){
      const dock=document.getElementById('navDock');
      const menuEl=document.getElementById('JreddHeaderMenuData');
      const normalizeNavTarget = (label, url, fallback) => {
        const key = String(label || '').trim().toLowerCase();
        if (key === 'home' || key === 'top') return '#shopify-section-hero';
        if (key === 'licensing' || key === 'license' || key === 'licenses') return '#shopify-section-licensing';
        if (key === 'bio' || key === 'about') return '#shopify-section-bio';
        if (key === 'contact') return '#shopify-section-contact';
        if (typeof url === 'string' && url.startsWith('#')) return url;
        return fallback;
      };
      try {
        const menu=menuEl ? JSON.parse(menuEl.textContent) : [];
        if (Array.isArray(menu) && menu.length) {
          menu.slice(0, NAV_ITEMS.length).forEach((link,i)=>{
            NAV_ITEMS[i].label = String(link.title || NAV_ITEMS[i].label).toUpperCase();
            NAV_ITEMS[i].target = normalizeNavTarget(link.title, link.url, NAV_ITEMS[i].target);
          });
        }
      } catch(_) {}
      dock.innerHTML=NAV_ITEMS.map((item,i)=>`
        <a class="nav-item${i===activeNav?' active':''}" href="${item.target}" data-nav="${i}" aria-label="${item.label}">
          <div class="nav-icon">${item.icon}</div>
          <span class="nav-label">${item.label}</span>
          <span class="nav-sub">${item.sub}</span>
        </a>
      `).join('');
      dock.querySelectorAll('.nav-item').forEach(el=>{
        el.addEventListener('click',e=>{
          e.preventDefault();
          activeNav=+el.dataset.nav;
          dock.querySelectorAll('.nav-item').forEach(n=>n.classList.remove('active'));
          el.classList.add('active');
          // v2.18: scroll-anchor to section instead of opening modal
          const target = NAV_ITEMS[activeNav]?.target;
          if (target) {
            const section = document.querySelector(target);
            if (section) section.scrollIntoView({ behavior:'smooth', block:'start' });
          }
        });
        el.addEventListener('keydown',e=>{ if(e.key==='Enter') el.click(); });
      });
    }

    /* ================================================================
       v2.18 — STICKY MINI-PLAYER on scroll
    ================================================================ */
    function initStickyPlayer() {
      const sticky = document.getElementById('v18Sticky');
      const hero   = document.getElementById('shopify-section-hero');
      if (!sticky || !hero) return;

      // Use IntersectionObserver to detect when hero leaves viewport
      const io = new IntersectionObserver(entries => {
        entries.forEach(e => {
          // Show sticky when hero is mostly out of view
          const shouldShow = !e.isIntersecting || e.intersectionRatio < 0.25;
          sticky.classList.toggle('visible', shouldShow);
          // v2.18: simultaneously reveal the translucent header backdrop
          // so wordmark + socials + sticky read as one unified header band
          document.body.classList.toggle('v18-sticky-on', shouldShow);
        });
      }, { threshold: [0, 0.25, 0.5, 1] });
      io.observe(hero);

      // Wire sticky buttons to the existing player controls
      const stPlay = document.getElementById('v18StickyPlay');
      const stPrev = document.getElementById('v18StickyPrev');
      const stNext = document.getElementById('v18StickyNext');
      const stCart = document.getElementById('v18StickyCart');  // v2.19
      const stBuy  = document.getElementById('v18StickyBuy');

      stPlay?.addEventListener('click', () => document.getElementById('btnPreview')?.click());
      stPrev?.addEventListener('click', () => document.getElementById('btnPrev')?.click());
      stNext?.addEventListener('click', () => document.getElementById('btnNext')?.click());
      // v2.19: mini-player cart icon opens the cart drawer directly.
      stCart?.addEventListener('click', () => openCart());
      stBuy ?.addEventListener('click', () => {
        document.getElementById('shopify-section-hero')?.scrollIntoView({ behavior:'smooth', block:'start' });
        setTimeout(() => document.getElementById('btnBuyTrigger')?.click(), 600);
      });
    }

    // Push the per-track metadata into the sticky bar whenever the current track changes
    // v2.19: per-track price = cheapest tier (Lease). Exclusive tier excluded from "From $X".
    function updateStickyBar(beat) {
      if (!beat) return;
      const t  = document.getElementById('v18StickyTitle');
      const g  = document.getElementById('v18StickyGenre');
      const m  = document.getElementById('v18StickyMeta');
      const a  = document.getElementById('v18StickyArt');
      const p  = document.getElementById('v18StickyPrice');
      const bp = document.getElementById('v18StickyBuyPrice');
      if (t) t.textContent = beat.name;
      if (g) g.textContent = beat.genre;
      if (m) m.textContent = `${beat.bpm} BPM · ${beat.key}`;
      // v4.1: mirror the metaobject album artwork into the sticky mini-player.
      if (a) {
        if (beat.artwork) {
          a.classList.add('has-img');
          a.innerHTML = `<img src="${beat.artwork}" alt="" loading="lazy" decoding="async">`;
        } else {
          a.classList.remove('has-img');
          a.textContent = String(beat.n).padStart(2,'0');
        }
      }
      const fromPrice = LICENSES[0].price; // Lease tier
      if (p)  p.textContent  = `From ${fmtPrice(fromPrice)}`;
      if (bp) bp.textContent = fmtPrice(fromPrice);
    }

    // Sync sticky play-icon with the actual transport state
    function setStickyPlaying(playing) {
      const ic = document.getElementById('v18StickyPlayIcon');
      if (!ic) return;
      ic.innerHTML = playing
        ? '<path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"/>'
        : '<path d="M8 5v14l11-7z"/>';
    }

    /* ================================================================
       v2.21 — COOKIE CONSENT MODULE
       Geo-aware, signal-respecting consent state with a public API:
         v21AcceptAll() · v21RejectNonEssential() · v21SaveCustom({...})
         v21OpenPreferences() · v21ResetConsent() · v21GetConsent()
         v21HasConsentFor('analytics' | 'functional' | 'essential')
       Custom event `v21:consent-changed` fires on every state mutation
       (handy for late-loaded analytics tags that listen for opt-in).

       NOTES FOR SHOPIFY INTEGRATION:
         · Essential server-set cookies (cart, _shopify_y, _shopify_s,
           _secure_session_id, checkout, _y, _orig_referrer, etc.)
           remain regardless of consent — they're set server-side and
           are strictly necessary under GDPR Article 6(1)(b).
         · localStorage cart (`jredd_cart_v1`) is essential by the
           same standard — required for the service the user requested.
         · For an authoritative geo lookup in Shopify, replace
           detectRegion()'s timezone heuristic with Shopify's
           Liquid `{{ localization.country.iso_code }}` injection
           or read the Cloudflare `CF-IPCountry` header on the edge.
         · The analytics init/teardown hooks include gtag consent-mode
           placeholders ready to drop GA4 / Tag Manager into.
    ================================================================ */
    const V21_CONSENT_KEY = 'jredd_consent_v1';

    // Timezones that imply a regulated jurisdiction. Conservative:
    // we include all EEA member states + EFTA, the UK & crown
    // dependencies, Switzerland, and all Brazilian zones.
    const V21_REGULATED_TZ = new Set([
      // EEA / EU member states + EFTA
      'Europe/Amsterdam','Europe/Athens','Europe/Berlin','Europe/Brussels',
      'Europe/Bucharest','Europe/Budapest','Europe/Copenhagen','Europe/Dublin',
      'Europe/Helsinki','Europe/Lisbon','Europe/Ljubljana','Europe/Luxembourg',
      'Europe/Madrid','Europe/Malta','Europe/Mariehamn','Europe/Monaco',
      'Europe/Oslo','Europe/Paris','Europe/Prague','Europe/Riga',
      'Europe/Rome','Europe/Sofia','Europe/Stockholm','Europe/Tallinn',
      'Europe/Vaduz','Europe/Vienna','Europe/Vilnius','Europe/Warsaw',
      'Europe/Zagreb','Atlantic/Reykjavik','Atlantic/Azores','Atlantic/Madeira',
      'Atlantic/Canary','Atlantic/Faroe','Europe/Bratislava','Europe/Nicosia',
      'Asia/Nicosia',
      // United Kingdom + crown dependencies + Gibraltar
      'Europe/London','Europe/Belfast','Europe/Isle_of_Man',
      'Europe/Jersey','Europe/Guernsey','Europe/Gibraltar',
      // Switzerland
      'Europe/Zurich',
      // Brazil
      'America/Sao_Paulo','America/Bahia','America/Belem','America/Boa_Vista',
      'America/Campo_Grande','America/Cuiaba','America/Eirunepe',
      'America/Fortaleza','America/Maceio','America/Manaus','America/Noronha',
      'America/Porto_Velho','America/Recife','America/Rio_Branco',
      'America/Santarem','America/Araguaina',
    ]);

    function v21DetectRegion() {
      try {
        const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
        if (!V21_REGULATED_TZ.has(tz)) return 'OTHER';
        if (tz === 'Europe/Zurich') return 'CH';
        if (tz.startsWith('America/')) return 'BR';
        if (tz === 'Europe/London' || tz === 'Europe/Belfast' ||
            tz === 'Europe/Isle_of_Man' || tz === 'Europe/Jersey' ||
            tz === 'Europe/Guernsey' || tz === 'Europe/Gibraltar') return 'UK';
        return 'EEA';
      } catch (_) {
        return 'OTHER';
      }
    }
    function v21DetectSignals() {
      const dnt = (navigator.doNotTrack === '1' ||
                   navigator.doNotTrack === 'yes' ||
                   window.doNotTrack === '1');
      const gpc = navigator.globalPrivacyControl === true;
      return { dnt, gpc };
    }
    function v21IsRegulated(region) {
      return region === 'EEA' || region === 'UK' || region === 'CH' || region === 'BR';
    }

    let v21State = null;

    function v21LoadStored() {
      try {
        const raw = localStorage.getItem(V21_CONSENT_KEY);
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        if (parsed && parsed.ver === 1) return parsed;
        return null;
      } catch (_) { return null; }
    }
    function v21Persist(state) {
      v21State = state;
      try { localStorage.setItem(V21_CONSENT_KEY, JSON.stringify(state)); } catch (_) {}
      document.dispatchEvent(new CustomEvent('v21:consent-changed', { detail: state }));
    }
    function v21GetConsent() { return v21State; }
    function v21HasConsentFor(cat) {
      if (!v21State) return false;
      return !!v21State.categories[cat];
    }

    function v21AcceptAll() {
      const sig = v21DetectSignals();
      v21Persist({
        ver: 1, ts: Date.now(),
        region: v21State?.region || v21DetectRegion(),
        mode: 'accept-all',
        categories: { essential: true, analytics: true, functional: true },
        dnt: sig.dnt, gpc: sig.gpc,
      });
      v21ApplyConsent();
      v21HideBanner();
    }
    function v21RejectNonEssential() {
      const sig = v21DetectSignals();
      v21Persist({
        ver: 1, ts: Date.now(),
        region: v21State?.region || v21DetectRegion(),
        mode: 'essential-only',
        categories: { essential: true, analytics: false, functional: false },
        dnt: sig.dnt, gpc: sig.gpc,
      });
      v21ApplyConsent();
      v21HideBanner();
    }
    function v21SaveCustom(cats) {
      const sig = v21DetectSignals();
      v21Persist({
        ver: 1, ts: Date.now(),
        region: v21State?.region || v21DetectRegion(),
        mode: 'custom',
        categories: {
          essential: true, // locked
          analytics: !!(cats && cats.analytics),
          functional: !!(cats && cats.functional),
        },
        dnt: sig.dnt, gpc: sig.gpc,
      });
      v21ApplyConsent();
      v21HideBanner();
    }
    function v21ResetConsent() {
      try { localStorage.removeItem(V21_CONSENT_KEY); } catch (_) {}
      v21State = null;
      // After reset, treat next pageload like a fresh visit
    }
    function v21OpenPreferences() { v18ModalOpen('cookie-prefs'); }

    /* --- Analytics gating ---------------------------------------------
       Production: drop the GA4 / Tag Manager script tag inside
       initAnalytics() guarded by a one-shot flag. The gtag consent-mode
       calls let GA respect the user's preference even if the script
       must remain on the page for Shopify reasons.
    -------------------------------------------------------------------- */
    let v21AnalyticsLoaded = false;
    function v21InitAnalytics() {
      if (v21AnalyticsLoaded) {
        // Already loaded — just flip consent state in gtag.
        if (window.gtag) window.gtag('consent', 'update', {
          analytics_storage: 'granted',
          ad_storage: 'denied',
          ad_user_data: 'denied',
          ad_personalization: 'denied',
        });
        return;
      }
      // Placeholder for the real GA4 loader. Kept inert so the mockup
      // stays free of network calls; uncomment when wiring up Shopify.
      // const s = document.createElement('script');
      // s.async = true;
      // s.src = 'https://www.googletagmanager.com/gtag/js?id=G-XXXXXXX';
      // document.head.appendChild(s);
      // window.dataLayer = window.dataLayer || [];
      // window.gtag = function(){ dataLayer.push(arguments); };
      // gtag('js', new Date());
      // gtag('consent','default',{ analytics_storage:'granted', ad_storage:'denied' });
      // gtag('config', 'G-XXXXXXX', { anonymize_ip: true });
      v21AnalyticsLoaded = true;
      // eslint-disable-next-line no-console
      console.info('[v21:consent] analytics: ENABLED (stub)');
    }
    function v21TeardownAnalytics() {
      if (window.gtag) window.gtag('consent', 'update', {
        analytics_storage: 'denied',
      });
      // eslint-disable-next-line no-console
      console.info('[v21:consent] analytics: DENIED (stub)');
    }
    function v21ApplyConsent() {
      if (!v21State) return;
      if (v21State.categories.analytics) v21InitAnalytics();
      else v21TeardownAnalytics();
      // Functional cookies hook would go here (e.g., remembering
      // beat-list filter state across sessions).
    }

    function v21ShowBanner() {
      const el = document.getElementById('v21Banner');
      if (!el) return;
      el.classList.add('visible');
      el.setAttribute('aria-hidden', 'false');
    }
    function v21HideBanner() {
      const el = document.getElementById('v21Banner');
      if (!el) return;
      el.classList.remove('visible');
      el.setAttribute('aria-hidden', 'true');
    }

    function v21InitConsent() {
      const region = v21DetectRegion();
      const sig = v21DetectSignals();
      const stored = v21LoadStored();

      if (stored) {
        v21State = stored;
        v21ApplyConsent();
        // If the user previously dismissed, don't reshow the banner.
        return;
      }

      if (v21IsRegulated(region)) {
        // Opt-in regime — must show banner, no analytics until consent.
        v21State = {
          ver: 1, ts: Date.now(), region,
          mode: 'pending',
          categories: { essential: true, analytics: false, functional: false },
          dnt: sig.dnt, gpc: sig.gpc,
        };
        v21TeardownAnalytics();
        v21ShowBanner();
      } else if (sig.dnt || sig.gpc) {
        // Non-regulated, but explicit opt-out signal — honor it
        // without showing the banner.
        v21Persist({
          ver: 1, ts: Date.now(), region,
          mode: 'signal-opt-out',
          categories: { essential: true, analytics: false, functional: false },
          dnt: sig.dnt, gpc: sig.gpc,
        });
        v21ApplyConsent();
      } else {
        // Non-regulated, no opt-out signal — analytics may default-on.
        v21Persist({
          ver: 1, ts: Date.now(), region,
          mode: 'implied',
          categories: { essential: true, analytics: true, functional: true },
          dnt: sig.dnt, gpc: sig.gpc,
        });
        v21ApplyConsent();
      }
    }

    function v21WireBanner() {
      const accept = document.getElementById('v21BannerAccept');
      const reject = document.getElementById('v21BannerReject');
      const manage = document.getElementById('v21BannerManage');
      accept?.addEventListener('click', v21AcceptAll);
      reject?.addEventListener('click', v21RejectNonEssential);
      manage?.addEventListener('click', () => {
        v21HideBanner();
        v21OpenPreferences();
      });
    }

    /* Renders the cookie-prefs modal body. Called from v18ModalOpen
       when layout === 'cookie-prefs'. */
    function renderCookiePrefsBody(body) {
      // Snapshot of the current state (or defaults for the first open).
      const s = v21State || {
        categories: { essential: true, analytics: false, functional: false },
      };
      const region = v21State?.region || v21DetectRegion();
      const sig = v21DetectSignals();
      const regionLabel = {
        EEA: 'European Economic Area', UK: 'United Kingdom',
        CH: 'Switzerland', BR: 'Brazil', OTHER: 'Outside the EEA / UK / CH / BR',
      }[region] || 'Unknown';

      body.innerHTML = `
        <div class="v21-prefs">
          <p class="v21-prefs__intro">
            Pick which cookie categories you allow. Essential cookies (cart, checkout, session, fraud-prevention) are always active because the Site cannot function without them. Analytics and functional cookies are off until you turn them on.
          </p>
          <div class="v21-prefs__row" data-locked="true">
            <div class="v21-prefs__row-h">
              Essential Cookies
              <span class="v21-locked-pill">Always Active</span>
            </div>
            <label class="v21-toggle" data-locked="true" aria-label="Essential cookies (always active)">
              <input type="checkbox" checked disabled>
              <span class="v21-toggle__track"></span>
              <span class="v21-toggle__thumb"></span>
            </label>
            <p class="v21-prefs__row-p">
              Required for cart persistence, secure checkout, session handling, and fraud prevention. Set server-side by Shopify and on your device by the Site. Cannot be disabled because the Site would not work.
            </p>
          </div>
          <div class="v21-prefs__row">
            <div class="v21-prefs__row-h">Analytics Cookies</div>
            <label class="v21-toggle" aria-label="Analytics cookies">
              <input type="checkbox" id="v21CatAnalytics" ${s.categories.analytics ? 'checked' : ''}>
              <span class="v21-toggle__track"></span>
              <span class="v21-toggle__thumb"></span>
            </label>
            <p class="v21-prefs__row-p">
              Help us understand which pages and beats are most useful. Aggregate, anonymized data only — no personal identifiers, no advertising network sharing. Off until you opt in.
            </p>
          </div>
          <div class="v21-prefs__row">
            <div class="v21-prefs__row-h">Functional / Preference Cookies</div>
            <label class="v21-toggle" aria-label="Functional and preference cookies">
              <input type="checkbox" id="v21CatFunctional" ${s.categories.functional ? 'checked' : ''}>
              <span class="v21-toggle__track"></span>
              <span class="v21-toggle__thumb"></span>
            </label>
            <p class="v21-prefs__row-p">
              Remember interface choices like your dismissed-banner state and filter preferences across visits. Convenience only; the Site works without them.
            </p>
          </div>
          <div class="v21-prefs__actions">
            <span class="v21-prefs__save-row-info">
              Region: ${regionLabel}${sig.dnt ? ' · DNT detected' : ''}${sig.gpc ? ' · GPC detected' : ''}
            </span>
            <button type="button" class="v21-prefs__ghost" id="v21PrefsReject">Reject Non-Essential</button>
            <button type="button" class="v18-modal__btn" id="v21PrefsSave">Save Preferences</button>
          </div>
        </div>
      `;
      body.scrollTop = 0;
      // Wire up the save / reject actions
      body.querySelector('#v21PrefsSave')?.addEventListener('click', () => {
        v21SaveCustom({
          analytics:  body.querySelector('#v21CatAnalytics')?.checked,
          functional: body.querySelector('#v21CatFunctional')?.checked,
        });
        v18ModalClose();
      });
      body.querySelector('#v21PrefsReject')?.addEventListener('click', () => {
        v21RejectNonEssential();
        v18ModalClose();
      });
    }

    /* ================================================================
       v2.18 — GENERIC MODAL SYSTEM
       Privacy + License Terms (Basic / Premium / Exclusive)
       ESC + overlay-click close, body-scroll lock, focus restore
    ================================================================ */
    const V18_MODAL_CONTENT = {
      // v2.20: Legal hub — tabbed modal containing 5 policy documents
      legal: {
        eyebrow: 'Legal',
        title: 'Legal Center',
        layout: 'tabs',
        tabs: [
          { key:'privacy',       label:'Privacy Policy' },
          { key:'terms',         label:'Terms of Service' },
          { key:'licensing',     label:'Licensing Agreement' },
          { key:'refunds',       label:'Refund Policy' },
          { key:'dmca',          label:'DMCA / Copyright' },
          { key:'cookies',       label:'Cookie Notice' },
          { key:'accessibility', label:'Accessibility' },
          { key:'ai',            label:'AI Use Policy' },
        ],
        panels: {
          privacy: `
            <h3>Overview</h3>
            <p>Afterwave Sound Inc. ("we," "us," "our") operates jredd.io and respects your privacy. This policy explains what information we collect when you visit the site, what we do with it, and the choices you have. By using the site you agree to the practices described here.</p>

            <h3>Information We Collect</h3>
            <p>Contact form data — name, email, project type, budget, and message. Submitted only when you choose to send a message.</p>
            <p>Order data — beats and license tiers added to your cart. Stored locally in your browser (localStorage key jredd_cart_v1) so your cart survives a refresh. Not transmitted to us until checkout.</p>
            <p>Payment data — handled exclusively by our payment processor (Stripe / PayPal). We never see or store your card number.</p>
            <p>Anonymous analytics — aggregate page views, referrers, and device type. No personally identifying information.</p>

            <h3>How We Use It</h3>
            <p>To respond to inquiries you submit through the contact form.</p>
            <p>To deliver beats you purchase and issue your license contract by email.</p>
            <p>To improve the site (which pages get the most attention, which beats convert).</p>

            <h3>Sharing &amp; Third Parties</h3>
            <p>We do not sell, rent, or trade your personal information. We share data only with the third parties strictly required to operate the site: our payment processor, our email delivery service, and our analytics provider. Each is bound by their own privacy policies and processes data on our behalf.</p>

            <h3>Cookies</h3>
            <p>We use a small number of first-party cookies to remember your cart and your modal-dismissal preferences. We do not use third-party advertising cookies.</p>

            <h3>Your Rights</h3>
            <p>You may request access to, correction of, or deletion of any personal information we hold about you by emailing privacy@jredd.io. We will respond within 30 days. If you are in the EU/UK or California, you have additional rights under the GDPR and CCPA respectively.</p>

            <h3>Data Retention</h3>
            <p>Contact submissions are retained for 24 months unless a working relationship is established. Order records are retained for ten (10) years for tax purposes; license audit-trail records (sufficient to evidence the existence and scope of an issued license, including the licensee's identity, license tier, beat licensed, and date of issuance) are retained indefinitely while the underlying license remains active or until the underlying composition enters the public domain. Anonymous analytics are retained for 26 months.</p>

            <h3>Security</h3>
            <p>We use industry-standard encryption (HTTPS), access controls, and reputable infrastructure providers. No method of transmission over the internet is 100% secure; we cannot guarantee absolute security, but we will notify affected users without undue delay in the event of a confirmed breach. Where GDPR applies, we will notify the relevant supervisory authority within 72 hours of becoming aware of a personal-data breach where required.</p>

            <h3>Legal Bases for Processing (GDPR)</h3>
            <p>Where the EU/UK GDPR applies, we process personal data on the following legal bases: (i) performance of a contract (Art. 6(1)(b)) — to deliver beats, issue licenses, and respond to inquiries; (ii) legitimate interests (Art. 6(1)(f)) — to operate, secure, and improve the Site, prevent fraud, and enforce our licenses; and (iii) consent (Art. 6(1)(a)) — for any non-essential cookies or marketing communications, where required. You may withdraw consent at any time without affecting prior processing.</p>

            <h3>Sub-Processors</h3>
            <p>We engage trusted third-party service providers ("sub-processors") to operate the Site and provide our services. These include: (i) ecommerce platform, checkout, payment processing, digital order fulfillment, hosting, and infrastructure — Shopify and affiliated service providers; (ii) email delivery — [TO BE DETERMINED]; and (iii) analytics and site performance monitoring — Google Analytics.</p>
            <p>Payment information submitted during checkout is processed securely through Shopify's payment infrastructure and payment service providers. We do not directly store full payment card numbers on our servers.</p>
            <p>Each sub-processor is contractually or legally obligated to maintain appropriate confidentiality, security, and data-protection safeguards. A current list of material sub-processors may be requested by contacting us at privacy@jredd.io.</p>

            <h3>International Data Transfers</h3>
            <p>Personal data may be transferred to, and processed in, the United States and other jurisdictions outside the European Economic Area and the United Kingdom. Where required, such transfers are protected by the European Commission's Standard Contractual Clauses (Decision 2021/914) or the UK International Data Transfer Addendum, and/or by sub-processors' certifications under the EU-U.S. and UK Extension Data Privacy Framework, as applicable.</p>

            <h3>California Privacy Notice (CCPA/CPRA)</h3>
            <p>We do not "sell" or "share" personal information as those terms are defined under the California Consumer Privacy Act, as amended by the California Privacy Rights Act. California residents have the right to (i) know what personal information we collect; (ii) request deletion or correction of their personal information; (iii) limit the use of sensitive personal information; and (iv) be free from discrimination for exercising these rights. To exercise any of these rights, contact privacy@jredd.io. We will verify your request using order data or other reasonable means before responding.</p>

            <h3>Children's Privacy</h3>
            <p>The Site is not directed to children under 13 (or under 16 in the EU/UK), and we do not knowingly collect personal information from such individuals. If you believe a child has provided personal information to us, please contact privacy@jredd.io and we will delete it.</p>

            <h3>Contact</h3>
            <p>Questions? privacy@jredd.io</p>

            <div class="v18-modal__meta">Last updated: 2026 · Afterwave Sound Inc.</div>
          `,

          terms: `
            <h3>Acceptance</h3>
            <p>By accessing or using jredd.io (the "Site") you agree to be bound by these Terms of Service ("Terms"). If you do not agree, do not use the Site. The Site is operated by Afterwave Sound Inc., the rightsholder of the J.Redd catalog.</p>

            <h3>Eligibility</h3>
            <p>You must be at least 18 years old (or the age of majority in your jurisdiction) to purchase a license. Purchases made on behalf of an entity must be made by an individual authorized to bind that entity.</p>

            <h3>Account &amp; Order Information</h3>
            <p>You agree to provide accurate, current information when submitting an order or an inquiry. Misrepresentation of identity or intended use may result in license revocation without refund.</p>

            <h3>Permitted Use of the Site</h3>
            <p>Browse the catalog and stream demo audio.</p>
            <p>Purchase licenses and download delivered files for personal or commercial use within the terms of your license.</p>
            <p>Contact us for custom work, sync placements, or exclusive licensing.</p>

            <h3>Prohibited Conduct</h3>
            <p>Scraping, mirroring, or republishing the catalog without written permission.</p>
            <p>Circumventing watermarks, demo tags, or download-gate systems.</p>
            <p>Distributing acquired beat files outside the scope of a valid license.</p>
            <p>Attempting to interfere with the Site's security, availability, or other users.</p>

            <h3>Intellectual Property</h3>
            <p>All beats, recordings, branding, and Site content are the property of Afterwave Sound Inc. or its licensors. Purchase of a license grants only the specific rights described in that license agreement.</p>

            <h3>Disclaimers</h3>
            <p>The Site and its content are provided "as is" without warranties of any kind, whether express or implied. We do not warrant that the Site will be uninterrupted or error-free.</p>

            <h3>Governing Law</h3>
            <p>These Terms are governed by the laws of the State of Colorado, United States, without regard to its conflict-of-laws principles. Any disputes shall be brought in the state or federal courts located in Denver County, Colorado.</p>

            <h3>Changes</h3>
            <p>We may revise these Terms at any time. Non-material revisions (clarifications, typographical corrections, address or contact updates, and similar housekeeping changes) take effect upon posting, and your continued use of the Site after the effective date constitutes acceptance. Material revisions — meaning changes that materially affect your rights, obligations, fees, license scope, or the binding arbitration provision — will be communicated to registered purchasers by email at the address on file and posted on the Site at least thirty (30) days before they take effect. Material revisions apply prospectively only; previously issued License Agreements continue to be governed by the version of these Terms in effect at the time of purchase, except where the change is required to comply with applicable law. Your continued use of the Site after a material revision's effective date constitutes acceptance of the revised Terms; if you do not agree, you must stop using the Site, and may opt out of the binding arbitration provision in accordance with its terms.</p>

            <h3>Acceptance at Checkout (Electronic Signature)</h3>
            <p>By selecting the "I agree to the Terms of Service, the applicable License Agreement, and the Refund and Privacy policies" checkbox and completing your purchase, you (i) affirmatively accept these Terms and the applicable License Agreement as a binding contract; (ii) provide an electronic signature under the U.S. ESIGN Act, the Uniform Electronic Transactions Act, and eIDAS where applicable; and (iii) acknowledge that your order constitutes affirmative assent to all linked policies. The order ID and timestamp will be retained as evidence of acceptance.</p>

            <h3>Taxes &amp; Currency</h3>
            <p>All prices are stated in U.S. Dollars (USD) and are exclusive of applicable sales tax, value-added tax (VAT), goods-and-services tax (GST), or similar consumption tax, which will be calculated and added at checkout based on the purchaser's jurisdiction. Licensee is responsible for any withholding tax that may apply to royalty payments made to Licensor.</p>

            <h3>EU/UK Consumer Right of Withdrawal — Express Waiver</h3>
            <p>Where the purchaser is a consumer resident in the European Union, the United Kingdom, or any jurisdiction granting a comparable cooling-off right for digital goods, the purchaser must, at checkout, affirmatively (i) request immediate performance of the contract by way of digital download, and (ii) acknowledge that this request causes the loss of the statutory right of withdrawal once the download has commenced. Without this express request and acknowledgment, the digital files will not be released.</p>

            <h3>Binding Arbitration; Class-Action Waiver</h3>
            <p>PLEASE READ THIS SECTION CAREFULLY. IT AFFECTS YOUR LEGAL RIGHTS. Any dispute, claim, or controversy arising out of or relating to these Terms, any License Agreement, the Site, or any beat licensed hereunder shall be resolved exclusively by binding individual arbitration administered by JAMS under its Streamlined Arbitration Rules, seated in Denver, Colorado, before a single arbitrator. YOU AND AFTERWAVE SOUND INC. EACH WAIVE THE RIGHT TO A JURY TRIAL AND TO PARTICIPATE IN ANY CLASS, COLLECTIVE, OR REPRESENTATIVE ACTION. Either party may bring a qualifying claim in a small-claims court of competent jurisdiction in lieu of arbitration. You may opt out of this arbitration provision by emailing legal@jredd.io with the subject line "Arbitration Opt-Out" within thirty (30) days of your first purchase; opting out does not waive any other provision of these Terms. Judgment on the award may be entered in any court of competent jurisdiction. This Section does not preclude either party from seeking injunctive or equitable relief in court for intellectual-property infringement.</p>

            <h3>Limitation of Liability</h3>
            <p>To the maximum extent permitted by law, Afterwave Sound Inc.'s aggregate liability arising out of or relating to these Terms, the Site, or any license issued hereunder shall not exceed the greater of (a) the total fees paid by the claimant in the twelve (12) months preceding the event giving rise to the claim, or (b) one hundred U.S. dollars (USD $100). In no event shall Afterwave Sound Inc. be liable for indirect, incidental, special, consequential, exemplary, or punitive damages, lost profits, lost revenue, loss of data, or loss of goodwill, whether in contract, tort, or otherwise, and whether or not Afterwave Sound Inc. has been advised of the possibility of such damages. Some jurisdictions do not allow the exclusion or limitation of incidental or consequential damages; in such jurisdictions, the foregoing limitations apply to the maximum extent permitted by law.</p>

            <h3>Indemnification</h3>
            <p>You agree to defend, indemnify, and hold harmless Afterwave Sound Inc., its officers, employees, and licensors from any claim, loss, liability, damage, or expense (including reasonable attorneys' fees) arising out of or related to (i) your use of the Site or any beat licensed hereunder; (ii) your breach of these Terms or any License Agreement; (iii) content you submit, post, or transmit; or (iv) your violation of any third-party right, including intellectual-property or privacy rights. The reciprocal indemnification owed by Licensor with respect to the underlying Composition is set forth in each License Agreement and is subject to the Limitation of Liability section.</p>

            <h3>AI-Generated Content &amp; Training Data</h3>
            <p>Use of beats, stems, recordings, branding, or other content from the Site as training data for any artificial-intelligence or machine-learning model is prohibited without prior written consent. The Site's AI Use Policy governs the disclosure of AI-assisted production within the catalog and is incorporated by reference into these Terms.</p>

            <h3>General Provisions</h3>
            <p>(a) Entire Agreement. These Terms, together with the applicable License Agreement, Refund Policy, Privacy Policy, Cookie Notice, DMCA Policy, and AI Use Policy, constitute the entire agreement between you and Afterwave Sound Inc. with respect to the subject matter hereof and supersede all prior agreements. (b) Severability. If any provision is held unenforceable, the remainder shall remain in full force and effect, and the unenforceable provision shall be reformed to the minimum extent necessary to be enforceable. (c) No Waiver. No failure or delay in exercising any right shall operate as a waiver thereof. (d) Assignment. You may not assign these Terms or any License Agreement without Licensor's prior written consent. Licensor may assign freely, including in connection with a merger, acquisition, or sale of assets. (e) Force Majeure. Neither party shall be liable for delay or failure in performance caused by events beyond its reasonable control, including acts of God, war, terrorism, civil unrest, pandemic, governmental action, network outage, or platform-provider failure. (f) Notices. Notices to Licensor shall be sent to legal@jredd.io; notices to Licensee shall be sent to the email address on file with Licensee's order. (g) Headings. Section headings are for convenience only and do not affect interpretation. (h) Survival. The Intellectual Property, Disclaimers, Limitation of Liability, Indemnification, Binding Arbitration, and General Provisions sections survive termination.</p>

            <h3>Contact</h3>
            <p>Questions about these Terms? legal@jredd.io</p>

            <div class="v18-modal__meta">Terms of Service v1.0 · Afterwave Sound Inc.</div>
          `,

          licensing: `
            <h3>Overview</h3>
            <p>This Licensing Agreement summarizes the three license tiers offered for J.Redd-produced compositions. Each tier is subject to a separate written agreement issued at the time of purchase or exclusive inquiry. For full per-tier contract language, use the "View License Terms" button on each licensing card. This page is a non-binding summary provided for convenience. The controlling document for any license is the per-tier License Agreement issued to the Licensee at the time of purchase (or, for exclusive licenses, the executed Exclusive License Agreement). In any conflict between this summary and an issued License Agreement, the issued License Agreement governs.</p>

            <h3>Tier 1 — Lease ($49)</h3>
            <p>Non-exclusive license</p>
            <p>MP3 + tagged WAV delivered instantly upon checkout</p>
            <p>Up to 50,000 combined streams, downloads, and sales</p>
            <p>Up to 2,500 physical copies</p>
            <p>One (1) non-monetized music video capped at 500,000 views</p>
            <p>Paid live performances permitted; personal social-media use</p>
            <p>Stems not included; sync / broadcast not permitted</p>
            <p>Required credit: "Prod. J.Redd" (non-removable)</p>
            <p>Term: ten (10) years, renewable</p>

            <h3>Tier 2 — Premium ($149)</h3>
            <p>Non-exclusive license with broader distribution rights</p>
            <p>MP3 + untagged WAV + full stem package</p>
            <p>Up to 250,000 combined streams, downloads, and sales</p>
            <p>Up to 10,000 physical copies</p>
            <p>One (1) monetized music video capped at 2,000,000 views</p>
            <p>Paid live performances permitted</p>
            <p>Required credit: "Prod. J.Redd" (non-removable)</p>
            <p>Term: ten (10) years, renewable</p>
            <p>Sync and broadcast above caps require upgrade</p>

            <h3>Tier 3 — Exclusive (Inquire)</h3>
            <p>Exclusive worldwide license — beat removed from the public catalog</p>
            <p>MP3 + untagged WAV + full stem package + pre-master WAV</p>
            <p>Unlimited streams, sales, and physical copies</p>
            <p>Unlimited monetized music videos</p>
            <p>Paid live performances, festivals, tours</p>
            <p>Sync rights for film, television, advertising, video games, broadcast</p>
            <p>Required credit: "Prod. J.Redd" (non-removable)</p>
            <p>Term: perpetual, unless terminated for cause</p>
            <p>Priced individually; inquire via licensing@jredd.io or the in-cart inquiry form</p>

            <h3>Universal Restrictions</h3>
            <p>No license is transferable or resaleable.</p>
            <p>Licensee may not register the underlying composition with a Performing Rights Organization claiming sole authorship.</p>
            <p>Underlying copyright in the composition is retained by Afterwave Sound Inc. in all tiers.</p>

            <h3>Contact</h3>
            <p>Licensing questions? licensing@jredd.io</p>

            <div class="v18-modal__meta">Licensing Agreement v1.0 · Afterwave Sound Inc.</div>
          `,

          refunds: `
            <h3>Digital Goods — All Sales Final</h3>
            <p>Due to the irrevocable nature of digital file delivery, all sales of Lease and Premium licenses are final once the download has been delivered. By completing checkout you acknowledge and accept this policy.</p>

            <h3>Exception: Duplicate Charge</h3>
            <p>If you are charged more than once for the same license due to a payment-processor error, we will refund the duplicate charge in full within 7 business days. Contact billing@jredd.io with the order ID and the date of the duplicate transaction.</p>

            <h3>Exception: Corrupted or Undeliverable Files</h3>
            <p>If the delivered file is corrupted, incomplete, or undeliverable due to a fault on our side, we will re-deliver the file at no additional cost. If we are unable to re-deliver within 14 days of confirmed report, you may request a full refund of that license.</p>

            <h3>Exclusive Licenses</h3>
            <p>Exclusive licenses are non-refundable once catalog removal has been initiated. If you wish to cancel an exclusive inquiry before the catalog-removal step, contact us within 24 hours of payment.</p>

            <h3>Chargebacks</h3>
            <p>Initiating a chargeback without first contacting us in good faith voids the associated license retroactively and may result in the license being revoked from all distribution platforms.</p>

            <h3>Exception: Confirmed Fraud</h3>
            <p>If a transaction is determined by Stripe, PayPal, or another reputable payment processor to be fraudulent (e.g., a stolen card or compromised account), we will refund the affected payment in full and void the associated license. Please report suspected fraud to billing@jredd.io within ten (10) days of the unauthorized charge so we can coordinate with the payment processor.</p>

            <h3>EU/UK Consumers — Right of Withdrawal</h3>
            <p>Consumers resident in the European Union, the United Kingdom, or other jurisdictions granting a comparable cooling-off right for digital goods waive that right at checkout in accordance with the "EU/UK Consumer Right of Withdrawal — Express Waiver" section of our Terms of Service. Where the waiver has been properly given and the download has commenced, the "Digital Goods — All Sales Final" rule in this Refund Policy applies. Where the waiver has not been given or the download has not commenced, the statutory right of withdrawal continues to apply.</p>

            <h3>How to Request</h3>
            <p>Email billing@jredd.io with your order ID, the date of purchase, and a brief description of the issue. We respond to refund requests within 5 business days. Approved refunds are processed to the original payment method within five (5) to ten (10) business days of approval; the actual time funds become available depends on the issuing bank or payment network.</p>

            <div class="v18-modal__meta">Refund Policy v1.0 · Afterwave Sound Inc.</div>
          `,

          dmca: `
            <h3>Copyright Statement</h3>
            <p>All beats, recordings, artwork, written content, branding, and audio-visual materials on jredd.io are the copyrighted property of Afterwave Sound Inc. or are used under valid license. Unauthorized reproduction, distribution, public performance, or derivative use is prohibited.</p>

            <h3>Filing a DMCA Notice</h3>
            <p>If you believe content on jredd.io infringes a copyright you own or control, send a written notice including the following required elements to our designated agent:</p>
            <p>Your physical or electronic signature.</p>
            <p>Identification of the copyrighted work claimed to be infringed.</p>
            <p>The URL or location on jredd.io of the allegedly infringing material.</p>
            <p>Your contact information (address, telephone, email).</p>
            <p>A statement that you have a good-faith belief that the use is not authorized.</p>
            <p>A statement, under penalty of perjury, that the information is accurate and that you are authorized to act on behalf of the rightsholder.</p>

            <h3>Designated Agent</h3>
            <p>
              Afterwave Sound Inc.<br>
              Attn: DMCA Agent<br>
              dmca@jredd.io<br>
              [Street Address — TO BE DETERMINED]<br>
              [City, State, ZIP — TO BE DETERMINED]<br>
              United States
            </p>
            <p>Our DMCA Designated Agent is registered with the U.S. Copyright Office in the DMCA Designated Agent Directory pursuant to 17 U.S.C. § 512(c)(2). Registration date: [TO BE DETERMINED upon filing at copyright.gov/dmca-directory].</p>

            <h3>Non-U.S. Copyright Notices (EU DSA / UK)</h3>
            <p>For copyright notices arising under non-U.S. law (including the EU Digital Services Act, Regulation (EU) 2022/2065, Articles 16–17), please submit a notice containing the same elements set out above to copyright@jredd.io. We will acknowledge and act on valid notices in accordance with applicable law.</p>

            <h3>Counter-Notice</h3>
            <p>If material you posted was removed in response to a DMCA notice and you believe the removal was in error, you may submit a counter-notice following the same procedure with the additional statements required by 17 U.S.C. § 512(g).</p>

            <h3>Repeat Infringers</h3>
            <p>It is our policy to terminate, in appropriate circumstances, the licenses or access of users who are determined to be repeat infringers.</p>

            <h3>Misuse</h3>
            <p>Knowingly submitting a false DMCA notice may result in liability under 17 U.S.C. § 512(f) and other applicable law.</p>

            <div class="v18-modal__meta">DMCA / Copyright Policy v1.0 · Afterwave Sound Inc.</div>
          `,

          cookies: `
            <h3>What Cookies Are</h3>
            <p>Cookies are small text files stored on your device when you visit jredd.io. They allow the Site to remember your actions (such as your cart contents) and preferences over time. This Notice describes the cookies and similar storage technologies we use, why we use them, and how you can control them. It supplements, and should be read together with, our Privacy Policy.</p>

            <h3>Categories We Use</h3>
            <p>Strictly Necessary (always on). Required for the Site to function. These include the localStorage key jredd_cart_v1 (to remember your cart across a refresh) and modal-dismissal preferences (so dismissed dialogs stay dismissed). Without these, the catalog and checkout do not work.</p>
            <p>Performance &amp; Analytics (consent-based in EU/UK). Used to count visits and understand how the catalog converts. We use a privacy-respecting analytics provider [TO BE CONFIRMED: Plausible / Fathom / GA4]. Data is aggregated and does not directly identify you.</p>
            <p>Payment Processor. Stripe and PayPal may set cookies on their checkout pages for fraud prevention and to authenticate your session. Their use is governed by their respective privacy and cookie policies.</p>
            <p>Advertising / Tracking. We do not currently use third-party advertising or cross-site tracking cookies. If this changes, we will update this Notice and obtain consent where required.</p>

            <h3>Your Choices</h3>
            <p>If you are visiting from the European Economic Area, the United Kingdom, Switzerland, or Brazil, a cookie banner will appear on your first visit. You may accept all, reject all non-essential cookies, or set granular preferences. You can change your selection at any time by clicking <a href="#" data-modal-open="cookie-prefs">"Cookie Settings"</a> in the Site footer. Visitors from other jurisdictions may opt out of analytics by enabling "Do Not Track" or "Global Privacy Control" signals in their browser, which we honor where technically supported. You may also block or delete cookies through your browser's settings; doing so may prevent parts of the Site from functioning.</p>

            <h3>Changes to This Notice</h3>
            <p>We may update this Notice from time to time. The "last updated" date below indicates when the current version took effect. Material changes will be highlighted on the Site.</p>

            <div class="v18-modal__meta">Cookie Notice v1.0 · Afterwave Sound Inc.</div>
          `,

          accessibility: `
            <h3>Our Commitment</h3>
            <p>Afterwave Sound Inc. is committed to making jredd.io accessible to the widest possible audience, including users with disabilities. We aim to conform with the Web Content Accessibility Guidelines (WCAG) 2.1, Level AA, published by the World Wide Web Consortium (W3C). These guidelines explain how to make web content more accessible to people with a wide range of disabilities, including visual, auditory, motor, and cognitive impairments.</p>

            <h3>Current Conformance Status</h3>
            <p>The Site is partially conformant with WCAG 2.1 Level AA. "Partially conformant" means that some parts of the content do not yet fully conform to the standard. We are working to identify and remediate non-conforming items. Demo audio is provided with text-based beat descriptions where reasonable; full transcripts of music are not provided because the works are instrumental.</p>

            <h3>Measures We Take</h3>
            <p>We design the Site with semantic HTML and ARIA attributes for screen-reader compatibility, ensure interactive controls are keyboard-navigable, target color-contrast ratios at or above WCAG AA thresholds, provide visible focus states, and avoid auto-playing audio on page load. We periodically test the Site with screen readers and automated accessibility tools, and address issues we discover through ordinary release cycles.</p>

            <h3>Known Limitations</h3>
            <p>We rely on third-party services (including Shopify, our payment processors, and embedded audio players) whose accessibility we do not directly control. Where third-party content does not meet our standards, we work with the vendor or seek alternatives. Older catalog artwork or marketing assets may lack alternative text; we are working through the backlog.</p>

            <h3>Feedback &amp; Requests</h3>
            <p>If you encounter an accessibility barrier on jredd.io or need information in an alternative format, please contact accessibility@jredd.io. We aim to respond within five (5) business days and to remediate substantiated barriers within a reasonable time. If you would like to purchase a license but cannot complete the checkout flow for accessibility reasons, contact support@jredd.io and we will assist you manually at no additional cost.</p>

            <h3>Formal Approval</h3>
            <p>This Statement was prepared on the date indicated below and reflects an internal self-assessment; it has not been audited by an independent third party. It will be reviewed and updated at least annually or when the Site undergoes a material redesign.</p>

            <div class="v18-modal__meta">Accessibility Statement v1.0 · Afterwave Sound Inc.</div>
          `,

          ai: `
            <h3>Scope &amp; Purpose</h3>
            <p>This AI Use Policy explains how Afterwave Sound Inc. uses generative-AI and machine-learning tools in producing the J.Redd catalog and operating jredd.io, and the rules that apply to Licensees with respect to AI use of beats licensed from the Site. It supplements, and should be read with, the Terms of Service and each License Agreement.</p>

            <h3>Our Production Disclosure</h3>
            <p>The beats offered on jredd.io are authored by J.Redd. Where AI-assisted tools are used in the creative process, their role is limited to stem separation or audio processing; (c) mastering assistance. We do not knowingly publish to the catalog any composition whose principal melodic, harmonic, or rhythmic content was generated by a third-party generative-AI model without human authorship sufficient to support copyright protection under applicable law. We do not represent any beat as "AI-generated" or use generative-AI to mimic a specific identifiable artist's voice or style without consent.</p>

            <h3>Sample &amp; Training-Data Integrity</h3>
            <p>We do not knowingly use generative-audio models that have been trained on a specific copyrighted recording in a manner that produces a substantially similar output. Where we use AI tools that may have been trained on broad public corpora, we limit their role to non-substantive processing (such as mastering or stem separation) and review outputs for originality. We do not submit any third-party copyrighted recording to any AI training pipeline.</p>

            <h3>Licensee AI Restrictions</h3>
            <p>Licensees shall not, and shall not permit any third party to: (i) submit, upload, or use any licensed Composition, New Song, or stem as training data for any generative-AI or machine-learning model; (ii) use any such material to mimic Licensor's voice, name, image, or production style in an AI-generated work; or (iii) describe or market AI-generated music as "produced by J.Redd" or as utilizing the Composition unless that AI-generated work was created within the scope of a valid license and properly credited. Licensor expressly reserves all text-and-data-mining opt-outs under EU Directive 2019/790, Article 4, and equivalent statutory rights.</p>

            <h3>Site Content &amp; Web Scraping</h3>
            <p>Automated scraping, crawling, indexing, or downloading of beats, demo audio, stems, branding, or written content from jredd.io for the purpose of training or fine-tuning any AI model is prohibited and constitutes a material breach of the Terms of Service. We prohibit the use of our content for AI training, dataset creation, or machine learning purposes except where expressly authorized. We may employ technical measures, including robots.txt directives and other machine-readable mechanisms, to communicate these restrictions.</p>

            <h3>Reporting &amp; Enforcement</h3>
            <p>If you believe an AI-generated work is using a Composition, our master recordings, or J.Redd's voice or likeness without authorization, please notify us at copyright@jredd.io with supporting links and details. We will investigate and pursue remedies under copyright, right-of-publicity, and contract law, as appropriate.</p>

            <div class="v18-modal__meta">AI Use Policy v1.0 · Afterwave Sound Inc.</div>
          `,
        },
      },

      // v2.21: Cookie preferences modal — three category rows + save/cancel
      'cookie-prefs': {
        eyebrow: 'Cookies',
        title: 'Cookie Preferences',
        layout: 'cookie-prefs',
      },

      // v2.20: Exclusive license inquiry form modal
      inquiry: {
        eyebrow: 'Exclusive License · Inquiry',
        title: 'Submit Inquiry',
        layout: 'inquiry',
        html: `
          <div class="v18-inquiry-summary" id="v20InquirySummary">
            <strong>You're inquiring about an exclusive license.</strong>
            Exclusive licenses are priced individually and require a brief intake so we can match the right beat to the right project. Lease and Premium licenses are handled separately at standard checkout.
          </div>
          <form class="v18-inquiry-form" id="v20InquiryForm" novalidate>
            <div class="v18-inquiry-grid">
              <div class="v18-inquiry-field">
                <label for="inq-artist">Artist Name</label>
                <input type="text" id="inq-artist" name="artist" required autocomplete="name">
              </div>
              <div class="v18-inquiry-field">
                <label for="inq-email">Email</label>
                <input type="email" id="inq-email" name="email" required autocomplete="email">
              </div>
            </div>
            <div class="v18-inquiry-grid">
              <div class="v18-inquiry-field">
                <label for="inq-budget">Budget Range</label>
                <select id="inq-budget" name="budget" required>
                  <option value="">Select…</option>
                  <option value="under-1k">Under $1,000</option>
                  <option value="1k-3k">$1,000 – $3,000</option>
                  <option value="3k-7k">$3,000 – $7,000</option>
                  <option value="7k-15k">$7,000 – $15,000</option>
                  <option value="15k-plus">$15,000+</option>
                  <option value="open">Open — need a quote</option>
                </select>
              </div>
              <div class="v18-inquiry-field">
                <label for="inq-timeline">Release Timeline</label>
                <select id="inq-timeline" name="timeline" required>
                  <option value="">Select…</option>
                  <option value="asap">ASAP / within 2 weeks</option>
                  <option value="month">Within 1 month</option>
                  <option value="quarter">Within 3 months</option>
                  <option value="six">3 – 6 months</option>
                  <option value="undecided">Undecided</option>
                </select>
              </div>
            </div>
            <div class="v18-inquiry-grid">
              <div class="v18-inquiry-field">
                <label for="inq-label">Label Involvement</label>
                <select id="inq-label" name="label" required>
                  <option value="">Select…</option>
                  <option value="independent">Independent / Self-released</option>
                  <option value="indie-label">Indie label</option>
                  <option value="major-label">Major label</option>
                  <option value="distro">Distribution deal (DistroKid, TuneCore, etc.)</option>
                  <option value="other">Other</option>
                </select>
              </div>
              <div class="v18-inquiry-field">
                <label for="inq-use">Intended Use</label>
                <select id="inq-use" name="use" required>
                  <option value="">Select…</option>
                  <option value="single">Standalone single</option>
                  <option value="album">Album / EP cut</option>
                  <option value="sync">Sync / film / TV</option>
                  <option value="advertising">Advertising / commercial</option>
                  <option value="mixtape">Mixtape</option>
                  <option value="other">Other</option>
                </select>
              </div>
            </div>
            <div class="v18-inquiry-field">
              <label for="inq-notes">Additional Notes <span style="text-transform:none;letter-spacing:.04em;color:var(--c-w40);font-weight:400">(optional)</span></label>
              <textarea id="inq-notes" name="notes" placeholder="Tell me which beat you have in mind and anything else relevant to the project…"></textarea>
            </div>
            <button type="submit" class="v18-modal__btn" id="v20InquirySubmit">Submit Inquiry</button>
          </form>
        `,
      },

      'terms-basic': {
        eyebrow: 'License Terms · Tier 1',
        title: 'Basic Lease — License Agreement',
        html: `
          <h3>Parties</h3>
          <p>This non-exclusive license ("Agreement") is between Afterwave Sound Inc. ("Licensor"), the rightsholder of the J.Redd catalog, and the purchaser ("Licensee"). The Agreement is effective on the date payment is received.</p>

          <h3>Grant of Rights</h3>
          <p>Licensor grants Licensee a non-exclusive, non-transferable, worldwide license to use the licensed beat ("Composition") in one (1) new derivative musical work ("New Song") created by Licensee.</p>

          <h3>Permitted Uses</h3>
          <p>Distribute the New Song through digital streaming platforms.</p>
          <p>Up to 50,000 combined streams, downloads, and physical/digital sales.</p>
          <p>Up to 2,500 physical copies (CDs, vinyl, USB).</p>
          <p>One (1) non-monetized music video, capped at 500,000 views across all platforms.</p>
          <p>For-profit live performances at venues with capacity under five hundred (500) attendees and where the Licensee's performance fee for the engagement is under five hundred U.S. dollars (USD $500); larger venues or higher performance fees require upgrade to Premium or Exclusive.</p>
          <p>Personal social media use (Instagram Reels, TikTok, YouTube Shorts) — non-monetized.</p>

          <h3>File Delivery</h3>
          <p>MP3 (320 kbps)</p>
          <p>Tagged WAV (24-bit / 48kHz)</p>

          <h3>Restrictions</h3>
          <p>This license is non-exclusive. Licensor retains the right to license the Composition to other Licensees.</p>
          <p>Licensee may not transfer, sublicense, or resell this Agreement.</p>
          <p>Licensee may not register the Composition (or the New Song) with any Performing Rights Organization claiming sole authorship of the underlying instrumental.</p>
          <p>Stems are not included in the Basic tier.</p>
          <p>Broadcast/sync uses require an upgraded license.</p>

          <h3>Credit</h3>
          <p>Licensee must include the credit "Prod. J.Redd" in all metadata, liner notes, and visible song credits.</p>

          <h3>Term</h3>
          <p>This Agreement is valid for ten (10) years from the date of purchase unless renewed or upgraded. If the license is not renewed, Licensee shall not commence any new distribution of the New Song. Releases already active on streaming platforms at the time of expiration may remain available, subject to the Permitted Uses caps. Licensee may renew or upgrade at any time via licensing@jredd.io. Licensor will provide email reminder notice at least ninety (90) days prior to expiration at the address on file with Licensee's order.</p>

          <h3>Ownership</h3>
          <p>Licensor retains all underlying copyrights to the Composition. The New Song is jointly held: Licensee owns the recorded performance (master) of the New Song; Licensor retains the underlying instrumental composition.</p>

          <h3>Refunds</h3>
          <p>Due to the digital nature of the product, all sales are final once the download has been delivered.</p>

          <h3>Publishing &amp; PRO Rights</h3>
          <p>The underlying instrumental Composition is a co-authored musical work. Licensor is credited as a fifty percent (50%) songwriter and publisher of any New Song embodying the Composition. Licensee shall identify J.Redd/ Afterwave Sound Inc. (Publisher; IPI #00706374937; affiliated with BMI) as a 50% co-writer and publisher on (i) any split sheet, (ii) Licensee's distributor metadata, (iii) any Performing Rights Organization registration, and (iv) the U.S. Mechanical Licensing Collective registration where applicable. Licensee shall not register the New Song as a sole-authored work. Failure to comply constitutes a material breach.</p>

          <h3>Mechanical Royalties</h3>
          <p>Licensee shall ensure that Licensor receives Licensor's fifty percent (50%) mechanical-royalty share for all interactive and non-interactive uses of the New Song, whether collected through Licensee's distributor, the U.S. Mechanical Licensing Collective, or applicable foreign collecting societies. Licensee shall provide Licensor with the ISRC, ISWC, distributor name, and release date of the New Song within thirty (30) days of first commercial release.</p>

          <h3>Content ID &amp; YouTube CMS</h3>
          <p>Licensor may enroll the Composition in YouTube Content ID or comparable rights-management systems. If a Licensee video incorporating the Composition is auto-claimed, Licensor will release the claim within five (5) business days of Licensee's submission, to support@jredd.io, of (i) the order ID, (ii) the YouTube video URL, and (iii) the YouTube channel name. Licensor retains the right to monetize, via Content ID or otherwise, any use of the Composition that is unlicensed or that exceeds the scope of this Agreement.</p>

          <h3>Representations &amp; Warranties</h3>
          <p>Licensor represents and warrants that (i) it owns or controls all rights necessary to grant this license; (ii) the Composition is original to Licensor and does not, to Licensor's knowledge, infringe any third-party copyright, trademark, or other proprietary right; and (iii) the Composition does not incorporate any uncleared third-party sample. Licensee represents and warrants that (i) Licensee is at least 18 years of age (or the age of majority in Licensee's jurisdiction) and has authority to enter this Agreement; and (ii) the vocals, lyrics, and additional material contributed by Licensee to the New Song are original to Licensee or properly licensed.</p>

          <h3>Indemnification</h3>
          <p>Licensor shall defend, indemnify, and hold harmless Licensee from third-party claims alleging that the underlying Composition (excluding any vocals, lyrics, or material added by Licensee) infringes a copyright, subject to the limitations of liability set forth in the Terms of Service. Licensee shall defend, indemnify, and hold harmless Licensor from third-party claims arising out of (i) the New Song's vocals, lyrics, or additional material; (ii) Licensee's use of the Composition beyond the scope of this license; or (iii) Licensee's breach of any obligation hereunder. Licensee's indemnification obligation is not capped.</p>

          <h3>AI &amp; Training-Data Restrictions</h3>
          <p>Licensee shall not, and shall not permit any third party to, submit, upload, or use the Composition, the New Song, or any stem or derivative thereof as training data for any artificial-intelligence or machine-learning model, including generative-audio, voice-cloning, or music-composition systems, without Licensor's prior written consent. Licensor expressly reserves all rights with respect to text-and-data-mining exceptions under EU Directive 2019/790 and equivalent legislation.</p>

          <div class="v18-modal__meta">Basic License v1.0 · Afterwave Sound Inc.</div>
        `,
      },

      'terms-premium': {
        eyebrow: 'License Terms · Tier 2',
        title: 'Premium Lease — License Agreement',
        html: `
          <h3>Parties</h3>
          <p>This non-exclusive license ("Agreement") is between Afterwave Sound Inc. ("Licensor"), the rightsholder of the J.Redd catalog, and the purchaser ("Licensee"). The Agreement is effective on the date payment is received.</p>

          <h3>Grant of Rights</h3>
          <p>Licensor grants Licensee a non-exclusive, non-transferable, worldwide license to use the licensed beat ("Composition") in one (1) new derivative musical work ("New Song") created by Licensee, with broader distribution and monetization rights than the Basic tier.</p>

          <h3>Permitted Uses</h3>
          <p>Distribute the New Song through digital streaming platforms.</p>
          <p>Up to 250,000 combined streams, downloads, and physical/digital sales.</p>
          <p>Up to 10,000 physical copies (CDs, vinyl, USB).</p>
          <p>One (1) monetized music video, capped at 2,000,000 views across all platforms.</p>
          <p>Paid live performances permitted.</p>
          <p>Full social media use including monetized content.</p>
          <p>Use of provided stem files for mixing, remixing, and creative arrangement.</p>

          <h3>File Delivery</h3>
          <p>MP3 (320 kbps)</p>
          <p>Untagged WAV (24-bit / 48 kHz)</p>
          <p>Full stem package (individual track WAVs: drums, bass, melody, FX as applicable)</p>

          <h3>Restrictions</h3>
          <p>This license is non-exclusive. Licensor retains the right to license the Composition to other Licensees.</p>
          <p>Licensee may not transfer, sublicense, or resell this Agreement.</p>
          <p>Sync placement (film, TV, advertising) requires a separate sync clearance.</p>
          <p>Broadcast radio play above 100,000 cumulative impressions requires upgrade to Exclusive.</p>

          <h3>Credit</h3>
          <p>Licensee must include the credit "Prod. J.Redd" in all metadata, liner notes, and visible song credits.</p>

          <h3>Term</h3>
          <p>This Agreement is valid for ten (10) years from the date of purchase unless renewed or upgraded. If the license is not renewed, Licensee shall not commence any new distribution of the New Song. Releases already active on streaming platforms at the time of expiration may remain available, subject to the Permitted Uses caps. Licensee may renew or upgrade at any time via licensing@jredd.io. Licensor will provide email reminder notice at least ninety (90) days prior to expiration at the address on file with Licensee's order.</p>

          <h3>Ownership</h3>
          <p>Licensor retains all underlying copyrights to the Composition. Licensee owns the recorded performance (master) of the New Song; Licensor retains the underlying instrumental composition.</p>

          <h3>Refunds</h3>
          <p>Due to the digital nature of the product, all sales are final once the download has been delivered.</p>

          <h3>Publishing &amp; PRO Rights</h3>
          <p>The underlying instrumental Composition is a co-authored musical work. Licensor is credited as a fifty percent (50%) songwriter and publisher of any New Song embodying the Composition. Licensee shall identify J.Redd/ Afterwave Sound Inc. (Publisher; IPI #00706374937; affiliated with BMI) as a 50% co-writer and publisher on (i) any split sheet, (ii) Licensee's distributor metadata, (iii) any Performing Rights Organization registration, and (iv) the U.S. Mechanical Licensing Collective registration where applicable. Licensee shall not register the New Song as a sole-authored work. Failure to comply constitutes a material breach.</p>

          <h3>Mechanical Royalties</h3>
          <p>Licensee shall ensure that Licensor receives Licensor's fifty percent (50%) mechanical-royalty share for all interactive and non-interactive uses of the New Song, whether collected through Licensee's distributor, the U.S. Mechanical Licensing Collective, or applicable foreign collecting societies. Licensee shall provide Licensor with the ISRC, ISWC, distributor name, and release date of the New Song within thirty (30) days of first commercial release.</p>

          <h3>Content ID &amp; YouTube CMS</h3>
          <p>Licensor may enroll the Composition in YouTube Content ID or comparable rights-management systems. If a Licensee video incorporating the Composition is auto-claimed, Licensor will release the claim within five (5) business days of Licensee's submission, to support@jredd.io, of (i) the order ID, (ii) the YouTube video URL, and (iii) the YouTube channel name. Licensor retains the right to monetize, via Content ID or otherwise, any use of the Composition that is unlicensed or that exceeds the scope of this Agreement.</p>

          <h3>Sync &amp; Broadcast</h3>
          <p>Sync placements (film, television, advertising, video games, branded content) require a separate written sync clearance from Licensor. Sync requests shall be submitted to sync@jredd.io. Sync fees are negotiated per use; Premium Licensees receive a fifteen percent (15%) discount off Licensor's then-current sync fee schedule. Broadcast radio play above 100,000 cumulative impressions requires upgrade to Exclusive.</p>

          <h3>Stem Use Restrictions</h3>
          <p>Stem files are licensed solely for Licensee's internal creative use in producing the New Song. Licensee shall not redistribute, resell, share, or upload stem files (in whole or in part) to any sample library, marketplace, file-sharing platform, or third party.</p>

          <h3>Representations &amp; Warranties</h3>
          <p>Licensor represents and warrants that (i) it owns or controls all rights necessary to grant this license; (ii) the Composition is original to Licensor and does not, to Licensor's knowledge, infringe any third-party copyright, trademark, or other proprietary right; and (iii) the Composition does not incorporate any uncleared third-party sample. Licensee represents and warrants that (i) Licensee is at least 18 years of age (or the age of majority in Licensee's jurisdiction) and has authority to enter this Agreement; and (ii) the vocals, lyrics, and additional material contributed by Licensee to the New Song are original to Licensee or properly licensed.</p>

          <h3>Indemnification</h3>
          <p>Licensor shall defend, indemnify, and hold harmless Licensee from third-party claims alleging that the underlying Composition (excluding any vocals, lyrics, or material added by Licensee) infringes a copyright, subject to the limitations of liability set forth in the Terms of Service. Licensee shall defend, indemnify, and hold harmless Licensor from third-party claims arising out of (i) the New Song's vocals, lyrics, or additional material; (ii) Licensee's use of the Composition beyond the scope of this license; or (iii) Licensee's breach of any obligation hereunder. Licensee's indemnification obligation is not capped.</p>

          <h3>AI &amp; Training-Data Restrictions</h3>
          <p>Licensee shall not, and shall not permit any third party to, submit, upload, or use the Composition, the New Song, or any stem or derivative thereof as training data for any artificial-intelligence or machine-learning model, including generative-audio, voice-cloning, or music-composition systems, without Licensor's prior written consent. Licensor expressly reserves all rights with respect to text-and-data-mining exceptions under EU Directive 2019/790 and equivalent legislation.</p>

          <div class="v18-modal__meta">Premium License v1.0 · Afterwave Sound Inc.</div>
        `,
      },

      'terms-exclusive': {
        eyebrow: 'License Terms · Tier 3',
        title: 'Exclusive — License Agreement',
        html: `
          <h3>Parties</h3>
          <p>This exclusive license ("Agreement") is between Afterwave Sound Inc. ("Licensor"), the rightsholder of the J.Redd catalog, and the purchaser ("Licensee"). The Agreement is effective on the date payment is received and the catalog removal is confirmed in writing.</p>

          <h3>Grant of Rights</h3>
          <p>Licensor grants Licensee an exclusive, non-transferable, worldwide license to use the licensed beat ("Composition") in commercial musical works. The Composition will be removed from the J.Redd catalog and no further licenses (Basic, Premium, or Exclusive) will be issued for it.</p>

          <h3>Permitted Uses</h3>
          <p>Unlimited streams, downloads, and physical/digital sales.</p>
          <p>Unlimited physical copies.</p>
          <p>Unlimited music videos, monetized.</p>
          <p>Paid live performances, including festivals and tours.</p>
          <p>Sync rights for film, television, advertising, video games, and broadcast media.</p>
          <p>Broadcast radio without impression caps.</p>
          <p>Sublicensing of the New Song master to label, distributor, sync agent, and bona-fide collaborators (the underlying instrumental Composition may not be sublicensed as a standalone work).</p>

          <h3>File Delivery</h3>
          <p>MP3 (320 kbps)</p>
          <p>Untagged WAV (24-bit / 48kHz)</p>
          <p>Full stem package (individual track WAVs: drums, bass, melody, FX as applicable)</p>
          <p>Pre-master WAV (32-bit float, processing-ready) — the final summed mix at 32-bit float resolution, suitable for third-party mastering; this is not a "master" for purposes of master-recording ownership.</p>

          <h3>Catalog Removal</h3>
          <p>Upon execution of this Agreement, the Composition will be removed from the public J.REDD catalog and from any active streaming demo placements within seven (7) business days. Any existing Basic or Premium licenses for the Composition that were issued before this Agreement remain valid for their original term but will not be renewed.</p>

          <h3>Ownership</h3>
          <p>Licensor retains the underlying copyright to the Composition. Licensee receives exclusive worldwide distribution rights for the duration of the Agreement. This Agreement does not transfer ownership of the master recording of the original Composition; it grants exclusive commercial-use rights.</p>

          <h3>Credit</h3>
          <p>Licensee must include the credit "Prod. J.Redd" in all metadata, liner notes, and visible song credits. The required credit shall not be removed under any circumstance.</p>

          <h3>Term</h3>
          <p>This Agreement is granted in perpetuity (lifetime) unless terminated for cause as defined herein.</p>

          <h3>Pricing &amp; Inquiry</h3>
          <p>Exclusive licenses are priced individually per Composition. Pricing reflects the beat's prior performance, demand, and the specific scope of the Licensee's intended use. To request an exclusive license, please use the contact form or email licensing@jredd.io.</p>

          <h3>Refunds</h3>
          <p>Exclusive licenses are non-refundable once the catalog removal has been initiated.</p>

          <h3>Publishing &amp; PRO Rights</h3>
          <p>The underlying Composition is a co-authored musical work. Licensor is credited as a fifty percent (50%) songwriter and publisher of any New Song embodying the Composition. Notwithstanding the exclusivity granted herein, Licensor retains its 50% publisher's share and 50% writer's share of the underlying composition copyright in perpetuity. Licensee shall identify J.Redd/ Afterwave Sound Inc. (Publisher; IPI #00706374937; affiliated with BMI) as a 50% co-writer and publisher on all split sheets, distributor metadata, PRO registrations, and MLC registrations. Licensee shall not register the New Song as a sole-authored work.</p>

          <h3>Mechanical Royalties</h3>
          <p>Licensee shall ensure that Licensor receives Licensor's fifty percent (50%) mechanical-royalty share for all interactive and non-interactive uses of the New Song, whether collected through Licensee's distributor, the U.S. Mechanical Licensing Collective, or applicable foreign collecting societies. Licensee shall provide Licensor with the ISRC, ISWC, distributor name, and release date of the New Song within thirty (30) days of first commercial release.</p>

          <h3>Content ID &amp; YouTube CMS</h3>
          <p>Upon execution of this Agreement, Licensor will (i) deregister the Composition from any Content ID or comparable rights-management system enrolled by Licensor, or (ii) whitelist the Licensee's designated channel and any successor channel administering the New Song. Licensor retains the right to claim and monetize any subsequent unlicensed use of the Composition by third parties.</p>

          <h3>Catalog Removal — Scope</h3>
          <p>The catalog removal described in this Agreement covers the public jredd.io catalog and all Licensor-controlled streaming demo placements on SoundCloud, YouTube, Spotify, Apple Music, and any beat marketplace under Licensor's administrative control. Third-party reposts beyond Licensor's direct control will be addressed by Licensor via good-faith takedown action under 17 U.S.C. § 512 upon Licensee's reasonable request.</p>

          <h3>Termination for Cause</h3>
          <p>"Cause" means any of the following: (i) material breach of the credit obligation that is not cured within thirty (30) days of Licensor's written notice; (ii) failure to remit Licensor's 50% publishing or mechanical-royalty share for two (2) or more consecutive quarters; (iii) initiation of a chargeback or non-payment of the license fee not resolved within thirty (30) days; (iv) Licensee's material misrepresentation as to identity or intended use; or (v) Licensee's sublicensing of the underlying instrumental Composition (as opposed to the New Song) to a third party without Licensor's written consent. Upon termination for Cause, the exclusive rights granted herein revert to Licensor; New Song masters released by Licensee in good faith prior to termination remain available, subject to Licensor's continuing publishing rights.</p>

          <h3>Sublicensing Scope</h3>
          <p>Licensee may sublicense the New Song (i.e., the recorded performance master incorporating the Composition) to Licensee's record label, distributor, sync agent, and bona-fide collaborators for ordinary commercial release, performance, and exploitation. Licensee shall not sublicense the underlying instrumental Composition as a standalone work, nor authorize any third party to use the Composition for any new derivative work other than the New Song, without Licensor's prior written consent.</p>

          <h3>Representations, Warranties &amp; Indemnification</h3>
          <p>Licensor represents and warrants that (i) it owns or controls all rights necessary to grant this exclusive license; (ii) the Composition is original to Licensor and does not, to Licensor's knowledge, infringe any third-party copyright, trademark, or other proprietary right; (iii) the Composition does not incorporate any uncleared third-party sample; and (iv) no prior exclusive license to the Composition has been granted to any other party. Licensor shall defend, indemnify, and hold harmless Licensee from third-party claims alleging that the underlying Composition (excluding material added by Licensee) infringes a copyright, subject to the limitations of liability set forth in the Terms of Service. Licensee shall defend, indemnify, and hold harmless Licensor from third-party claims arising out of (a) the New Song's vocals, lyrics, or additional material; (b) Licensee's use beyond the scope of this license; or (c) Licensee's breach of any obligation hereunder. Licensee's indemnification obligation is not capped.</p>

          <h3>Content Carve-Out &amp; Non-Disparagement</h3>
          <p>The Composition shall not be used in connection with content depicting pornography, hate speech, content advocating illegal violence, or political advocacy without Licensor's prior written consent, such consent not to be unreasonably withheld. Each party agrees not to make any public statement disparaging the other in connection with the Composition or the New Song.</p>

          <h3>AI &amp; Training-Data Restrictions</h3>
          <p>Licensee shall not, and shall not permit any third party to, submit, upload, or use the Composition, the New Song, or any stem or derivative thereof as training data for any artificial-intelligence or machine-learning model, including generative-audio, voice-cloning, or music-composition systems, without Licensor's prior written consent. Licensor expressly reserves all rights with respect to text-and-data-mining exceptions under EU Directive 2019/790 and equivalent legislation.</p>

          <div class="v18-modal__meta">Exclusive License v1.0 · Afterwave Sound Inc.</div>
        `,
      },
    };

    let v18ModalLastFocused = null;
    function v18ModalOpen(key) {
      // Support sub-keys for the legal hub: "legal:terms", "legal:dmca", etc.
      let [rootKey, subKey] = key.split(':');
      const data = V18_MODAL_CONTENT[rootKey];
      const modal = document.getElementById('v18Modal');
      if (!data || !modal) return;

      v18ModalLastFocused = document.activeElement;

      document.getElementById('v18ModalEyebrow').textContent = data.eyebrow;
      document.getElementById('v18ModalTitle').textContent   = data.title;
      const body = document.getElementById('v18ModalBody');
      body.scrollTop = 0;

      // Remove any prior tab bar / wrap (from a previous open) and clean up listeners
      const existingWrap = modal.querySelector('.v18-modal__tabs-wrap');
      if (existingWrap) {
        if (existingWrap._cleanup) existingWrap._cleanup();
        existingWrap.remove();
      }

      if (data.layout === 'tabs') {
        // v2.20.1 — wrap-in-wrap pattern: outer wrap hosts the gradient
        // fade-mask edges; inner element is the horizontal scroll container.
        const head = modal.querySelector('.v18-modal__head');
        const tabWrap = document.createElement('div');
        tabWrap.className = 'v18-modal__tabs-wrap';

        const tabBar = document.createElement('div');
        tabBar.className = 'v18-modal__tabs';
        tabBar.setAttribute('role', 'tablist');
        tabBar.setAttribute('aria-label', data.title || 'Tabs');

        const initialTab = (data.tabs.find(t => t.key === subKey) || data.tabs[0]).key;
        tabBar.innerHTML = data.tabs.map(t => `
          <button class="v18-modal__tab" role="tab"
                  data-legal-tab="${t.key}"
                  tabindex="${t.key === initialTab ? '0' : '-1'}"
                  aria-selected="${t.key === initialTab ? 'true' : 'false'}">${t.label}</button>
        `).join('');
        tabWrap.appendChild(tabBar);
        head.insertAdjacentElement('afterend', tabWrap);

        body.innerHTML = data.tabs.map(t => `
          <section class="v18-legal__panel ${t.key === initialTab ? 'active' : ''}"
                   role="tabpanel" data-legal-panel="${t.key}"
                   aria-label="${t.label}">${data.panels[t.key]}</section>
        `).join('');

        // ---- Overflow detection: toggle fade-mask edges based on scroll position
        const updateOverflow = () => {
          const max = tabBar.scrollWidth - tabBar.clientWidth;
          const s = tabBar.scrollLeft;
          tabWrap.classList.toggle('has-overflow-start', s > 4);
          tabWrap.classList.toggle('has-overflow-end', max > 4 && s < max - 4);
        };
        const scrollActiveIntoView = (smooth = true) => {
          const sel = tabBar.querySelector('.v18-modal__tab[aria-selected="true"]');
          if (sel) sel.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', inline: 'center', block: 'nearest' });
        };

        tabBar.addEventListener('scroll', updateOverflow, { passive: true });
        const ro = ('ResizeObserver' in window) ? new ResizeObserver(updateOverflow) : null;
        if (ro) ro.observe(tabBar);
        const onWinResize = () => { updateOverflow(); };
        window.addEventListener('resize', onWinResize, { passive: true });

        // Initial paint — wait one frame so layout settles
        requestAnimationFrame(() => {
          // Active tab in view first (instant on open, no jarring smooth-scroll)
          scrollActiveIntoView(false);
          updateOverflow();
        });

        // Persist cleanup so we can detach when modal closes / reopens
        tabWrap._cleanup = () => {
          tabBar.removeEventListener('scroll', updateOverflow);
          if (ro) ro.disconnect();
          window.removeEventListener('resize', onWinResize);
        };

        // ---- Tab activation
        const activate = (btn, { focus = false } = {}) => {
          if (!btn) return;
          const k = btn.dataset.legalTab;
          tabBar.querySelectorAll('.v18-modal__tab').forEach(b => {
            const selected = b.dataset.legalTab === k;
            b.setAttribute('aria-selected', selected ? 'true' : 'false');
            b.setAttribute('tabindex', selected ? '0' : '-1');
          });
          body.querySelectorAll('.v18-legal__panel').forEach(p => p.classList.toggle('active', p.dataset.legalPanel === k));
          body.scrollTop = 0;
          if (focus) btn.focus();
          // Always ensure the active tab is visible — important on narrow screens
          btn.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        };
        tabBar.addEventListener('click', e => {
          const btn = e.target.closest('[data-legal-tab]');
          if (btn) activate(btn);
        });
        // Keyboard navigation on the tablist (arrow keys + Home/End)
        tabBar.addEventListener('keydown', e => {
          const tabs = [...tabBar.querySelectorAll('.v18-modal__tab')];
          const idx = tabs.findIndex(b => b.getAttribute('aria-selected') === 'true');
          let next = idx;
          if (e.key === 'ArrowRight') next = (idx + 1) % tabs.length;
          else if (e.key === 'ArrowLeft') next = (idx - 1 + tabs.length) % tabs.length;
          else if (e.key === 'Home') next = 0;
          else if (e.key === 'End') next = tabs.length - 1;
          else return;
          e.preventDefault();
          activate(tabs[next], { focus: true });
        });
      } else if (data.layout === 'inquiry') {
        // v2.20 — Exclusive license inquiry form
        body.innerHTML = data.html;
        const form = body.querySelector('#v20InquiryForm');
        if (form) form.addEventListener('submit', handleInquirySubmit);
      } else if (data.layout === 'cookie-prefs') {
        // v2.21 — Cookie preferences (toggle rows + save/cancel)
        renderCookiePrefsBody(body);
      } else {
        body.innerHTML = data.html;
      }

      modal.classList.add('open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('v18-no-scroll');

      // Move focus into the modal for keyboard users
      const closeBtn = modal.querySelector('.v18-modal__close');
      if (closeBtn) closeBtn.focus({ preventScroll: true });
    }
    /* v2.20 — Exclusive inquiry submit handler.
       Opens a pre-filled mailto to licensing@jredd.io with the inquiry
       payload, then replaces the form with an elegant in-modal confirmation. */
    function handleInquirySubmit(e) {
      e.preventDefault();
      const form = e.currentTarget;
      const fd = new FormData(form);

      // Native required-field check
      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      const escape = v => String(v || '').replace(/\s+/g, ' ').trim();
      const exclusiveBeats = cart
        .filter(c => {
          const l = LICENSES.find(x => x.key === c.licenseKey);
          return l && l.price === null;
        })
        .map(c => BEATS[c.beatIdx]?.name)
        .filter(Boolean);

      const lines = [
        `Artist Name: ${escape(fd.get('artist'))}`,
        `Email: ${escape(fd.get('email'))}`,
        `Budget Range: ${escape(fd.get('budget'))}`,
        `Intended Use: ${escape(fd.get('use'))}`,
        `Label Involvement: ${escape(fd.get('label'))}`,
        `Release Timeline: ${escape(fd.get('timeline'))}`,
        '',
        `Beats of Interest: ${exclusiveBeats.length ? exclusiveBeats.join(', ') : '(none specified)'}`,
        '',
        'Additional Notes:',
        escape(fd.get('notes')) || '(none)',
      ];

      const subject = encodeURIComponent(`J.REDD — Exclusive License Inquiry · ${escape(fd.get('artist')) || 'New inquiry'}`);
      const body = encodeURIComponent(lines.join('\n'));
      // Fire the mailto in the same tab so the user's mail client opens cleanly
      window.location.href = `mailto:licensing@jredd.io?subject=${subject}&body=${body}`;

      // Render confirmation state in-place (no redirect, no abrupt jump)
      const bodyEl = document.getElementById('v18ModalBody');
      if (bodyEl) {
        bodyEl.innerHTML = `
          <div class="v18-inquiry-confirm">
            <div class="v18-inquiry-confirm__icon" aria-hidden="true">
              <svg viewBox="0 0 24 24"><path d="M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>
            </div>
            <h3>Inquiry Sent</h3>
            <p>Your inquiry has been prepared and forwarded to <strong>licensing@jredd.io</strong>. I review every exclusive request personally and respond within 48 hours.</p>
            <p style="margin-top:14px; font-size:12px; color:var(--c-w60);">If your mail client didn't open automatically, you can reach out directly at the address above.</p>
          </div>
        `;
        bodyEl.scrollTop = 0;
      }
      // Clear the exclusive items from the cart once the inquiry is sent
      cart = cart.filter(c => {
        const l = LICENSES.find(x => x.key === c.licenseKey);
        return !(l && l.price === null);
      });
      persistCart();
      renderCart();
    }

    function v18ModalClose() {
      const modal = document.getElementById('v18Modal');
      if (!modal || !modal.classList.contains('open')) return;
      modal.classList.remove('open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('v18-no-scroll');
      // Return focus to whoever opened the modal
      if (v18ModalLastFocused && typeof v18ModalLastFocused.focus === 'function') {
        v18ModalLastFocused.focus({ preventScroll: true });
        v18ModalLastFocused = null;
      }
    }
    function initV18Modals() {
      // Open triggers (delegated so dynamically-injected triggers also work)
      document.addEventListener('click', e => {
        const opener = e.target.closest('[data-modal-open]');
        if (opener) {
          e.preventDefault();
          v18ModalOpen(opener.dataset.modalOpen);
          return;
        }
        const closer = e.target.closest('[data-modal-close]');
        if (closer) {
          e.preventDefault();
          v18ModalClose();
        }
      });
      // ESC closes
      document.addEventListener('keydown', e => {
        if (e.key === 'Escape') v18ModalClose();
      });
    }

    /* ================================================================
       v2.18 — Wire licensing deep-dive CTAs + contact form + scroll cue
    ================================================================ */
    function initV18Extras() {
      // Licensing deep-dive: each CTA scrolls back to hero, selects tier, expands purchase
      document.querySelectorAll('[data-buy-tier]').forEach(btn => {
        btn.addEventListener('click', () => {
          const tier = btn.dataset.buyTier;
          const tierIdx = LICENSES.findIndex(l => l.key === tier);
          if (tierIdx >= 0) activeLicense = tierIdx;
          document.getElementById('shopify-section-hero')?.scrollIntoView({ behavior:'smooth', block:'start' });
          setTimeout(() => {
            renderLicensing();
            document.getElementById('btnBuyTrigger')?.click();
          }, 700);
        });
      });

      // Contact form — preview-only stub (no backend)
      const form = document.getElementById('v18ContactForm');
      const submit = document.getElementById('cfSubmit');
      if (form && submit) {
        form.addEventListener('submit', e => {
          e.preventDefault();
          submit.textContent = 'Sent ✓';
          submit.disabled = true;
          submit.style.opacity = '.7';
        });
      }

      // Scroll cue: hide once the user has scrolled
      const cue = document.getElementById('scrollCue');
      if (cue) {
        window.addEventListener('scroll', () => {
          cue.style.opacity = window.scrollY > 60 ? '0' : '';
        }, { passive: true });
      }
    }

    /* ================================================================
       SEARCH + FILTER SYSTEM
    ================================================================ */
    function uniq(arr) { return [...new Set(arr)]; }
    const FILTER_OPTS = {
      genre: uniq(BEATS.map(b=>b.genre)).sort(),
      mood:  uniq(BEATS.map(b=>b.mood)).sort(),
      key:   uniq(BEATS.map(b=>b.key)).sort(),
      bpm:   BPM_RANGES.map(r=>r.label),
    };

    function applyFilters() {
      const q = searchQuery.trim().toLowerCase();
      visibleBeats = BEATS.filter(b => {
        if (filters.genre && b.genre !== filters.genre) return false;
        if (filters.mood  && b.mood  !== filters.mood)  return false;
        if (filters.key   && b.key   !== filters.key)   return false;
        if (filters.bpm) {
          const r = BPM_RANGES.find(rr => rr.label === filters.bpm);
          if (r && !r.test(b)) return false;
        }
        if (q) {
          const blob = (b.name+' '+b.genre+' '+b.mood+' '+b.key+' '+b.tags.join(' ')).toLowerCase();
          if (!blob.includes(q)) return false;
        }
        return true;
      });
      updateFilterChipsUI();
    }

    function updateFilterChipsUI() {
      ['genre','mood','key','bpm'].forEach(k => {
        const chip = document.querySelector(`.filter-chip[data-filter="${k}"]`);
        const val  = document.getElementById('val' + k[0].toUpperCase() + k.slice(1));
        if (filters[k]) {
          chip.classList.add('active');
          val.textContent = ` · ${filters[k]}`;
        } else {
          chip.classList.remove('active');
          val.textContent = '';
        }
      });
      const hasAny = !!(filters.genre || filters.mood || filters.key || filters.bpm);
      document.getElementById('filterBar').classList.toggle('has-filters', hasAny);
    }

    function openFilterDropdown(filter, chipEl) {
      closeFilterDropdown();
      const menu = document.createElement('div');
      menu.className = 'filter-menu';
      const opts = FILTER_OPTS[filter];
      menu.innerHTML = opts.map(o =>
        `<div class="filter-menu__opt${filters[filter]===o?' selected':''}" data-val="${o}">${o}</div>`
      ).join('');
      document.body.appendChild(menu);
      // Position
      const r = chipEl.getBoundingClientRect();
      menu.style.left = r.left + 'px';
      menu.style.top  = (r.bottom + 6) + 'px';
      requestAnimationFrame(()=> menu.classList.add('open'));
      chipEl.setAttribute('aria-expanded','true');

      menu.querySelectorAll('.filter-menu__opt').forEach(opt => {
        opt.addEventListener('click', e => {
          const v = opt.dataset.val;
          filters[filter] = filters[filter] === v ? null : v;
          applyFilters();
          renderBeatList();
          closeFilterDropdown();
        });
      });
      openFilterMenu = { filter, el: menu, chip: chipEl };
    }
    function closeFilterDropdown() {
      if (!openFilterMenu) return;
      openFilterMenu.chip.setAttribute('aria-expanded','false');
      openFilterMenu.el.remove();
      openFilterMenu = null;
    }
    document.addEventListener('click', e => {
      if (openFilterMenu && !openFilterMenu.el.contains(e.target) && !e.target.closest('.filter-chip')) {
        closeFilterDropdown();
      }
    });

    /* ================================================================
       BUY EXPANDER
    ================================================================ */
    function expandPurchase() { document.getElementById('purchaseZone').classList.add('expanded'); }
    function collapsePurchase() { document.getElementById('purchaseZone').classList.remove('expanded'); }

    /* ================================================================
       CART
    ================================================================ */
    // v4.1: each cart entry is { beatIdx, licenseKey, qty }. One line per beat;
    // re-adding the same beat increments its quantity (which is exactly how the
    // quantity stepper lets a user correct an accidental duplicate add).
    function addToCart(beatIdx, licenseKey) {
  const lic = LICENSES.find(l => l.key === licenseKey);
  const exists = cart.findIndex(c => c.beatIdx === beatIdx);
  if (exists >= 0) {
    if (cart[exists].licenseKey === licenseKey) {
      cart[exists].qty = (cart[exists].qty || 1) + 1;
    } else {
      // License switched on an existing beat — keep the chosen quantity.
      cart[exists].licenseKey = licenseKey;
    }
  } else {
    cart.push({ beatIdx, licenseKey, qty: 1 });
  }
  persistCart();
  renderCart();
  pulseCartIcon();
  if (lic && lic.price !== null) {
    const entry = cart.find(c => c.beatIdx === beatIdx);
    syncShopifyQty(beatIdx, licenseKey, entry ? entry.qty : 1);
  }
}
    // v4.1: adjust the quantity of an existing cart line. Clamped to a minimum
    // of 1 — removal is handled by the dedicated remove (×) button.
    function changeQty(idx, delta) {
      const item = cart[idx];
      if (!item) return;
      const next = Math.max(1, (item.qty || 1) + delta);
      if (next === item.qty) return;
      item.qty = next;
      persistCart();
      renderCart();
      syncShopifyQty(item.beatIdx, item.licenseKey, item.qty);
    }
    function removeFromCart(idx) {
      const item = cart[idx];
      cart.splice(idx, 1);
      persistCart(); // v2.18
      renderCart();
      if (item) syncShopifyQty(item.beatIdx, item.licenseKey, 0); // v4.1: zero the Shopify line
    }

    // v4.1: best-effort sync of a beat's license line to an absolute quantity in
    // the real Shopify Ajax cart. Skips silently when there is no mapped variant
    // (e.g. fallback/mockup data or an Exclusive inquiry with no purchasable
    // variant) so totals in the UI never depend on a network round-trip.
    async function syncShopifyQty(beatIdx, licenseKey, qty) {
      const variantId = selectedVariantId(beatIdx, licenseKey);
      if (!variantId) return;
      const JSON_HEADERS = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
      try {
        if (qty <= 0) {
          // Remove the line (no-op if it isn't there).
          await fetch('/cart/change.js', {
            method: 'POST', headers: JSON_HEADERS,
            body: JSON.stringify({ id: String(variantId), quantity: 0 })
          });
          return;
        }
        // change.js sets an absolute quantity but ONLY on a line that already
        // exists; for a brand-new line it responds 404, so fall back to add.js
        // (adding the full quantity, not a fixed 1).
        const res = await fetch('/cart/change.js', {
          method: 'POST', headers: JSON_HEADERS,
          body: JSON.stringify({ id: String(variantId), quantity: qty })
        });
        let lineExists = false;
        if (res.ok) {
          const data = await res.json();
          lineExists = (data.items || []).some(it =>
            String(it.variant_id) === String(variantId) || String(it.id) === String(variantId));
        }
        if (!lineExists) {
          await fetch('/cart/add.js', {
            method: 'POST', headers: JSON_HEADERS,
            body: JSON.stringify({ id: String(variantId), quantity: qty })
          });
        }
      } catch (err) {
        console.warn('[J.REDD] Shopify cart sync failed', err);
      }
    }

    /* v2.18: localStorage cart persistence */
    const CART_KEY = 'jredd_cart_v1';
    function persistCart() {
      try { localStorage.setItem(CART_KEY, JSON.stringify(cart)); } catch(_) {}
      cartPersistenceCleared = false; // v4.7: new writes re-arm the checkout cleaner
    }
    /* v4.7: called when the customer intentionally hands off to Shopify
       Checkout. Clears ONLY the storefront persistence (localStorage entry +
       in-memory cache) so stale items can't be restored after a purchase.
       Idempotent and defensive: safe on empty carts, safe if the entry is
       already gone, guarded so a failure can never block the checkout redirect.
       Shopify's backend cart is NOT touched. */
    let cartPersistenceCleared = false;
    function clearCartPersistence() {
      if (cartPersistenceCleared) return;
      cartPersistenceCleared = true;
      try { localStorage.removeItem(CART_KEY); } catch(_) {}
      try {
        cart = [];
        renderCart(); // keep the UI truthful if the page is restored from bfcache
      } catch(_) {}
    }
    function hydrateCartFromStorage() {
      try {
        const raw = localStorage.getItem(CART_KEY);
        if (!raw) return;
        const parsed = JSON.parse(raw);
        if (Array.isArray(parsed)) {
          // Filter to valid entries only, normalizing quantity (v4.1).
          cart = parsed.filter(c =>
            Number.isInteger(c?.beatIdx) && c.beatIdx >= 0 && c.beatIdx < BEATS.length &&
            typeof c?.licenseKey === 'string' && LICENSES.some(l => l.key === c.licenseKey)
          ).map(c => ({
            beatIdx: c.beatIdx,
            licenseKey: c.licenseKey,
            qty: Math.max(1, parseInt(c.qty, 10) || 1)
          }));
          renderCart();
        }
      } catch(_) { /* corrupt entry — ignore */ }
    }

    /* ================================================================
       v4.8 — CART RECONCILIATION SYSTEM
       Shopify's cart (GET /cart.js) is the ONLY source of truth. The persisted
       local cart (localStorage jredd_cart_v1 + the in-memory `cart` array) is
       strictly a display cache. On every page load (and bfcache restore) the
       two are compared; on any difference the local state is OVERWRITTEN from
       Shopify — never merged.

       Comparison normalization: purchasable lines reduce to
       { variant_id, quantity }, order-insensitive; UI-only metadata is ignored.
       Exclusive-inquiry entries (license price === null) never exist in the
       Shopify cart by design (they route to the inquiry flow, not checkout),
       so they are excluded from the comparison and preserved through a CASE B
       overwrite. CASE C (Shopify cart empty) clears ALL persisted cart data,
       including inquiry entries, per spec.
    ================================================================ */
    // variant_id → { beatIdx, licenseKey } reverse lookup. First-wins so a
    // premium tier that fell back to the lease variant id maps to lease.
    function buildVariantLookup() {
      const map = {};
      BEATS.forEach((b, i) => {
        const v = b.variants || {};
        ['lease', 'premium', 'exclusive'].forEach(k => {
          const id = v[k];
          if (id && !(String(id) in map)) map[String(id)] = { beatIdx: i, licenseKey: k };
        });
      });
      return map;
    }
    function isInquiryEntry(c) {
      const lic = LICENSES.find(l => l.key === c.licenseKey);
      return !!lic && lic.price === null;
    }
    // Normalize a list of {variantId, qty} into a canonical comparable string.
    function normalizeLines(lines) {
      return lines
        .map(l => ({ v: String(l.variantId), q: Math.max(1, parseInt(l.qty, 10) || 1) }))
        .sort((a, b) => (a.v < b.v ? -1 : a.v > b.v ? 1 : 0))
        .map(l => l.v + 'x' + l.q)
        .join('|');
    }
    function localPurchasableLines() {
      const lines = [];
      let unmappable = false;
      cart.forEach(c => {
        if (isInquiryEntry(c)) return; // inquiry-only, never in Shopify cart
        const variantId = selectedVariantId(c.beatIdx, c.licenseKey);
        if (variantId) lines.push({ variantId, qty: c.qty || 1 });
        else unmappable = true; // fallback/mockup data with no real variants
      });
      return { lines, unmappable };
    }

    let reconcileInFlight = null;
    async function reconcileCartState() {
      // Idempotent: concurrent calls share one round-trip.
      if (reconcileInFlight) return reconcileInFlight;
      reconcileInFlight = (async () => {
        let shopifyCart;
        try {
          const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
          if (!res.ok) throw new Error('cart.js ' + res.status);
          shopifyCart = await res.json();
          if (!shopifyCart || !Array.isArray(shopifyCart.items)) throw new Error('malformed cart.js');
        } catch (err) {
          // Network/parse failure → temporarily trust the persisted cache;
          // do NOT overwrite anything. (Also the local-mockup path.)
          return { status: 'offline' };
        }

        // persistedCart = the already-hydrated local store (in-memory `cart`).
        const local = localPurchasableLines();
        if (local.unmappable) return { status: 'unmapped' }; // no real variant data — nothing meaningful to compare

        // CASE C — Shopify cart is empty: full reset of ALL persisted state.
        if (shopifyCart.items.length === 0) {
          if (cart.length === 0) return { status: 'equal' }; // already clean, no re-render
          try { localStorage.removeItem(CART_KEY); } catch (_) {}
          cart = [];
          renderCart();   // badges → 0 everywhere, drawer body → empty state
          closeCart();    // close the mini cart/drawer if open
          return { status: 'reset' };
        }

        const shopifyLines = shopifyCart.items.map(it => ({
          variantId: it.variant_id != null ? it.variant_id : it.id,
          qty: it.quantity
        }));
        const cartsAreEqual = normalizeLines(shopifyLines) === normalizeLines(local.lines);

        // CASE A — carts match: do nothing (zero re-render → zero flicker).
        if (cartsAreEqual) return { status: 'equal' };

        // CASE B — carts differ: TRUST SHOPIFY ALWAYS. Rebuild the UI cart
        // entirely from shopifyCart (never merge), keeping only local
        // inquiry-only entries which have no Shopify counterpart by design.
        const lookup = buildVariantLookup();
        const rebuilt = [];
        shopifyLines.forEach(l => {
          const hit = lookup[String(l.variantId)];
          if (hit) rebuilt.push({ beatIdx: hit.beatIdx, licenseKey: hit.licenseKey, qty: Math.max(1, l.qty) });
          // Lines not present in the player's catalog data can't be displayed
          // in the drawer; they remain safely in Shopify's cart for checkout.
        });
        cart.forEach(c => { if (isInquiryEntry(c)) rebuilt.push(c); });
        cart = rebuilt;
        persistCart();  // overwrite persisted storage from the Shopify source
        renderCart();   // re-render drawer, badges, totals from Shopify state
        return { status: 'overwritten' };
      })().finally(() => { reconcileInFlight = null; });
      return reconcileInFlight;
    }

    // Re-reconcile when the page is restored from the back/forward cache
    // (e.g. returning from Shopify Checkout via the Back button).
    window.addEventListener('pageshow', e => { if (e.persisted) reconcileCartState(); });

    function pulseCartIcon() {
      const ic = document.getElementById('cartIcon');
      ic.classList.remove('pulse');
      void ic.offsetWidth;
      ic.classList.add('pulse');
    }
    // v2.19: returns { subtotal, hasInquire } so the cart UI can render
    // "$X + Inquire" when an exclusive (null-price) item is in the cart.
    function cartTotal() {
      let subtotal = 0, hasInquire = false;
      cart.forEach(c => {
        const lic = LICENSES.find(l => l.key === c.licenseKey);
        if (!lic) return;
        if (lic.price === null) hasInquire = true;
        else subtotal += lic.price * (c.qty || 1); // v4.1: respect quantity
      });
      return { subtotal, hasInquire };
    }
    // v4.1: total units across all lines (used for the cart badges / count).
    function cartUnitCount() {
      return cart.reduce((n, c) => n + (c.qty || 1), 0);
    }
    function renderCart() {
      const body = document.getElementById('cartBody');
      const icon = document.getElementById('cartIcon');
      const badge = document.getElementById('cartBadge');
      const total = document.getElementById('cartTotal');
      const countTxt = document.getElementById('cartCountTxt');

      const units = cartUnitCount(); // v4.1: count quantities, not just lines
      badge.textContent = units;
      countTxt.textContent = String(units).padStart(2,'0');
      icon.classList.toggle('has-items', cart.length > 0);
      // v2.19: real totals restored. Exclusive items show as "Inquire"
      // and are excluded from the numeric subtotal — handled by cartTotal().
      const result = cartTotal();
      total.textContent = !cart.length
        ? '—'
        : (result.subtotal === 0 && result.hasInquire ? 'Inquire'
            : (result.hasInquire ? `${fmtPrice(result.subtotal)} + Inquire` : fmtPrice(result.subtotal)));
      total.classList.toggle('tba', cart.length > 0 && result.subtotal === 0 && result.hasInquire);
      // Mini-player cart badge (v2.19) — mirror cart count
      const miniBadge = document.getElementById('v18StickyCartBadge');
      if (miniBadge) {
        miniBadge.textContent = units;
        const miniBtn = document.getElementById('v18StickyCart');
        if (miniBtn) miniBtn.classList.toggle('has-items', cart.length > 0);
      }

      if (!cart.length) {
        body.innerHTML = `<div class="cart-empty">
          <svg viewBox="0 0 24 24"><path d="M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12L8.1 13h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49A1.003 1.003 0 0 0 20 4H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z"/></svg>
          <div class="cart-empty__title">Cart is Empty</div>
          <div class="cart-empty__sub">Add beats from the catalog to begin.</div>
        </div>`;
        return;
      }
      body.innerHTML = cart.map((c, i) => {
        const b = BEATS[c.beatIdx];
        const lic = LICENSES.find(l => l.key === c.licenseKey);
        const qty = c.qty || 1;
        const isInquire = lic.price === null;
        // v4.1: price shown is the LINE total (unit price × quantity).
        const priceHtml = isInquire
          ? `<div class="cart-item__price tba">Inquire</div>`
          : `<div class="cart-item__price">${fmtPrice(lic.price * qty)}</div>`;
        // v4.1: quantity stepper. Exclusive (inquiry) lines stay at a single
        // unit, so they show a static "Qty 1" badge instead of a stepper.
        const qtyHtml = isInquire
          ? `<div class="cart-item__qty cart-item__qty--locked">Qty 1</div>`
          : `<div class="cart-item__qty" role="group" aria-label="Quantity for ${b.name}">
              <button class="cart-qty__btn" type="button" data-qd="dec" data-i="${i}" aria-label="Decrease quantity"${qty <= 1 ? ' disabled' : ''}>
                <svg viewBox="0 0 24 24"><path d="M19 13H5v-2h14z"/></svg>
              </button>
              <span class="cart-qty__val" aria-live="polite">${qty}</span>
              <button class="cart-qty__btn" type="button" data-qd="inc" data-i="${i}" aria-label="Increase quantity">
                <svg viewBox="0 0 24 24"><path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6z"/></svg>
              </button>
            </div>`;
        const thumbInner = b.artwork
          ? `<img src="${b.artwork}" alt="" loading="lazy" decoding="async">`
          : String(b.n).padStart(2,'0');
        return `<div class="cart-item">
          <div class="cart-item__thumb ${b.tc}${b.artwork ? ' has-img' : ''}">${thumbInner}</div>
          <div class="cart-item__meta">
            <div class="cart-item__name">${b.name}</div>
            <div class="cart-item__license">${lic.label}</div>
            ${qtyHtml}
          </div>
          ${priceHtml}
          <button class="cart-item__remove" data-i="${i}" aria-label="Remove">
            <svg viewBox="0 0 24 24"><path d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>
          </button>
        </div>`;
      }).join('');
      body.querySelectorAll('.cart-item__remove').forEach(b => {
        b.addEventListener('click', () => removeFromCart(+b.dataset.i));
      });
      // v4.1: wire quantity steppers.
      body.querySelectorAll('.cart-qty__btn').forEach(btn => {
        btn.addEventListener('click', () => {
          changeQty(+btn.dataset.i, btn.dataset.qd === 'inc' ? 1 : -1);
        });
      });

      // v2.20: when an Exclusive license is in the cart, append a contextual
      // instruction so the user understands checkout will route to an inquiry.
      if (cartHasExclusive()) {
        const note = document.createElement('div');
        note.className = 'cart-exclusive-note';
        note.innerHTML = `<strong>Click checkout to submit an inquiry</strong> for an Exclusive license. Lease and Premium licenses must be purchased separately.`;
        body.appendChild(note);
      }
    }
    function cartHasExclusive() {
      return cart.some(c => {
        const l = LICENSES.find(x => x.key === c.licenseKey);
        return l && l.price === null;
      });
    }
    function openCart() {
      document.getElementById('cartDrawer').classList.add('open');
      document.getElementById('cartOverlay').classList.add('open');
    }
    function closeCart() {
      document.getElementById('cartDrawer').classList.remove('open');
      document.getElementById('cartOverlay').classList.remove('open');
    }

    /* ================================================================
       IN-PLAYER MODAL (Purchasing Info / Bio / Contact)
    ================================================================ */
    const MODAL_CONTENT = {
      purchase: {
        title: 'PURCHASING INFO', sub: 'Licensing',
        html: `
          <div class="mc-section">
            <p class="mc-eyebrow">Licensing Tiers</p>
            <h2 class="mc-h">Choose the right license for your project</h2>
            <p class="mc-p">Every J.Redd beat is available under three tiers. Each tier unlocks deeper file formats and broader usage rights.</p>
            <div class="mc-grid">
              <div class="mc-card">
                <div class="mc-card__label">Lease</div>
                <div class="mc-card__price">$49</div>
                <div class="mc-card__desc">MP3 + WAV. Non-exclusive use. Up to 50k streams.</div>
              </div>
              <div class="mc-card">
                <div class="mc-card__label">Premium</div>
                <div class="mc-card__price">$149</div>
                <div class="mc-card__desc">MP3 + WAV + Stems. Non-exclusive. Up to 250k streams.</div>
              </div>
              <div class="mc-card">
                <div class="mc-card__label">Exclusive</div>
                <div class="mc-card__price">Inquire</div>
                <div class="mc-card__desc">MP3 + WAV + Stems + Pre-Master WAV. Exclusive distribution rights.</div>
              </div>
            </div>
          </div>
          <div class="mc-section">
            <p class="mc-eyebrow">Delivery</p>
            <p class="mc-p">Files are delivered instantly upon checkout via secure download link. License contract sent to your email.</p>
          </div>
          <div class="mc-section">
            <p class="mc-eyebrow">Need Custom Work?</p>
            <p class="mc-p">Reach out via the Contact tab for custom production, sound design, and mix-mastering services.</p>
          </div>`
      },
      bio: {
        title: 'BIO', sub: 'About',
        html: `
          <div class="mc-section">
            <p class="mc-eyebrow">Producer</p>
            <h2 class="mc-h">J.Redd — Sound. Vision. Future.</h2>
            <p class="mc-p">J.Redd is a producer and audio engineer crafting cinematic, future-forward beats across trap, hip-hop, R&B, and drill. His work fuses analog warmth with digital precision — built for artists who want their sound to feel inevitable.</p>
            <p class="mc-p">With a catalog spanning hundreds of placements and an obsessive focus on sonic identity, J.Redd's catalog is engineered for streaming, sync, and the stage.</p>
          </div>
          <div class="mc-section">
            <p class="mc-eyebrow">Studio</p>
            <p class="mc-p">Based in Denver. Digital/Analog hybrid workflow. Hardware-driven production and processing chain.</p>
          </div>
          <div class="mc-section">
            <p class="mc-eyebrow">Press</p>
            <p class="mc-p">Featured in modern producer circles, with credits on independent and major-label releases. Available for interviews on request.</p>
          </div>`
      },
      contact: {
        title: 'CONTACT', sub: 'Reach Out',
        html: `
          <div class="mc-section">
            <p class="mc-eyebrow">Get In Touch</p>
            <h2 class="mc-h">Let's build something undeniable.</h2>
            <p class="mc-p">Use the form below for custom beats, placements, sync licensing, or general inquiries. I respond within 48 hours.</p>
          </div>
          <div class="mc-section">
            <input class="mc-input" type="text" placeholder="Your name">
            <input class="mc-input" type="email" placeholder="Email address">
            <input class="mc-input" type="text" placeholder="Subject (optional)">
            <textarea class="mc-textarea" placeholder="Tell me what you're working on..."></textarea>
            <button class="mc-btn" onclick="this.textContent='Sent ✓';this.disabled=true;">Send Message</button>
          </div>
          <div class="mc-section">
            <p class="mc-eyebrow">Direct</p>
            <p class="mc-p">booking@jredd.com &nbsp;·&nbsp; @jredd on socials</p>
          </div>`
      },
    };
    function openModal(kind) {
      const data = MODAL_CONTENT[kind];
      if (!data) return;
      modalOpen = kind;
      const modal = document.getElementById('playerModal');
      document.getElementById('modalTitle').innerHTML = `${data.title} <em>${data.sub}</em>`;
      document.getElementById('modalBody').innerHTML  = data.html;
      modal.classList.add('open');
      modal.setAttribute('aria-hidden','false');
    }
    function closeModal() {
      modalOpen = null;
      const modal = document.getElementById('playerModal');
      modal.classList.remove('open');
      modal.setAttribute('aria-hidden','true');
      // Reset nav active to HOME if user closed via X
      activeNav = 0;
      document.querySelectorAll('.nav-item').forEach((n,i) => n.classList.toggle('active', i===0));
    }

    /* ================================================================
       ATTACH EXTRA HANDLERS (search, filters, buy, cart, modal, mini)
    ================================================================ */
    function attachExtraHandlers() {
      // Search: expandable icon → input
      const search       = document.getElementById('searchInput');
      const searchWrap   = document.getElementById('searchCollapsible');
      const searchBtn    = document.getElementById('searchTrigger');

      const expandSearch = () => {
        searchWrap.classList.add('expanded');
        searchBtn.setAttribute('aria-expanded','true');
        search.removeAttribute('tabindex');
        // Focus AFTER the width transition starts so input is selectable
        setTimeout(() => search.focus(), 60);
      };
      const collapseSearch = () => {
        if (search.value.trim() !== '') return; // don't collapse if user has a query
        searchWrap.classList.remove('expanded');
        searchBtn.setAttribute('aria-expanded','false');
        search.setAttribute('tabindex','-1');
      };

      searchBtn.addEventListener('click', () => {
        if (searchWrap.classList.contains('expanded')) {
          // If empty, collapse; otherwise re-focus
          if (search.value.trim() === '') collapseSearch();
          else search.focus();
        } else {
          expandSearch();
        }
      });

      search.addEventListener('input', e => {
        searchQuery = e.target.value;
        applyFilters();
        renderBeatList();
      });
      search.addEventListener('blur', collapseSearch);
      search.addEventListener('keydown', e => {
        if (e.key === 'Escape') {
          search.value = '';
          searchQuery = '';
          applyFilters();
          renderBeatList();
          search.blur();
          collapseSearch();
        }
      });

      // Filter chips
      document.querySelectorAll('.filter-chip').forEach(chip => {
        chip.addEventListener('click', e => {
          e.stopPropagation();
          const f = chip.dataset.filter;
          if (openFilterMenu && openFilterMenu.filter === f) closeFilterDropdown();
          else openFilterDropdown(f, chip);
        });
      });
      document.getElementById('filterClear').addEventListener('click', () => {
        filters.genre = filters.mood = filters.key = filters.bpm = null;
        applyFilters();
        renderBeatList();
      });

      // Buy expander
      document.getElementById('btnBuyTrigger').addEventListener('click', expandPurchase);
      document.getElementById('purchaseClose').addEventListener('click', collapsePurchase);
      document.getElementById('btnCart').addEventListener('click', () => {
        addToCart(activeIdx, LICENSES[activeLicense].key);
        collapsePurchase();
      });

      // Cart
      document.getElementById('cartIcon').addEventListener('click', openCart);
      document.getElementById('cartClose').addEventListener('click', closeCart);
      document.getElementById('cartOverlay').addEventListener('click', closeCart);
      document.getElementById('btnKeep').addEventListener('click', closeCart);
      document.getElementById('btnCheckout').addEventListener('click', () => {
        // v2.20: Exclusive-license carts go through inquiry, not direct checkout.
        if (cartHasExclusive()) {
          closeCart();
          // Brief delay so the drawer-close animation reads before the modal opens
          setTimeout(() => v18ModalOpen('inquiry'), 280);
          return;
        }
        const btn = document.getElementById('btnCheckout');
        const original = btn.textContent;
        btn.textContent = 'Opening checkout…';
        btn.disabled = true;
        // v4.7: clicking Checkout transfers ownership of the purchase flow to
        // Shopify. Clear ONLY the storefront persistence layer so a completed
        // purchase can never be restored as a stale cart on the next visit.
        // Shopify's backend cart is untouched — checkout proceeds exactly as
        // before with the same line items.
        clearCartPersistence();
        window.location.href = '/checkout';
      });

      // Modal close
      document.getElementById('modalClose').addEventListener('click', closeModal);

      // Mini-player controls inside modal
      document.getElementById('miniPlay').addEventListener('click', () => { togglePlay(); updateMiniPlayIcon(); });
      document.getElementById('miniPrev').addEventListener('click', () => { jumpTo((activeIdx-1+BEATS.length)%BEATS.length); updateMiniPlayIcon(); });
      document.getElementById('miniNext').addEventListener('click', () => { jumpTo((activeIdx+1)%BEATS.length); updateMiniPlayIcon(); });
    }
    function updateMiniPlayIcon() {
      const icon = document.getElementById('miniPlayIcon');
      if (!icon) return;
      if (isPlaying) icon.innerHTML = '<path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"/>';
      else           icon.innerHTML = '<path d="M8 5v14l11-7z"/>';
    }

    /* ================================================================
       PARTICLE SYSTEM
    ================================================================ */
    function spawnParticles(){
      const layer=document.getElementById('particleLayer');
      const COLORS=['rgba(255,26,26,1)','rgba(180,10,10,1)','rgba(242,242,242,1)','rgba(200,20,20,1)'];
      for(let i=0;i<50;i++){
        const p=document.createElement('div');
        p.className='particle';
        const sz=Math.random()*2+.4;
        const left=Math.random()*100;
        const delay=Math.random()*20;
        const dur=Math.random()*16+12;
        const color=COLORS[Math.floor(Math.random()*COLORS.length)];
        const dx=(Math.random()-.5)*110;
        p.style.cssText=`width:${sz}px;height:${sz}px;left:${left}%;bottom:-8px;background:${color};box-shadow:0 0 ${sz*4}px ${color};opacity:0;animation:pFloat ${dur}s ${delay}s ease-in-out infinite;--dx:${dx}px;`;
        layer.appendChild(p);
      }
      const style=document.createElement('style');
      style.textContent=`@keyframes pFloat{0%{transform:translateY(0) translateX(0) scale(1);opacity:0;}8%{opacity:.4;}50%{transform:translateY(-45vh) translateX(calc(var(--dx)*.5)) scale(1.12);}92%{opacity:.1;}100%{transform:translateY(-92vh) translateX(var(--dx)) scale(.35);opacity:0;}}`;
      document.head.appendChild(style);
    }

    /* ================================================================
       CURSOR GLOW
    ================================================================ */
    const cg=document.getElementById('cursorGlow');
    document.addEventListener('mousemove',e=>{
      cg.style.left=e.clientX+'px'; cg.style.top=e.clientY+'px';
    });

    /* ================================================================
       KEYBOARD
    ================================================================ */
    document.addEventListener('keydown',e=>{
      if(e.target!==document.body) return;
      if(e.code==='Space'){ e.preventDefault(); togglePlay(); syncEqPause(); }
      if(e.code==='ArrowRight'){ jumpTo((activeIdx+1)%BEATS.length); }
      if(e.code==='ArrowLeft') { jumpTo((activeIdx-1+BEATS.length)%BEATS.length); }
    });

    /* Periodic full re-render */
    setInterval(()=>{ if(isPlaying) renderBeatList(); },5000);

    /* ================================================================
       v4.2 — PUBLIC API
       Lets the product landing page (product-page.js) reuse the EXACT same
       cart engine, license model, and cart drawer instead of duplicating it.
       On a product page BEATS holds the single beat (index 0).
    ================================================================ */
    window.JREDD = window.JREDD || {};
    window.JREDD.addToCart   = (beatIdx, licenseKey) => addToCart(beatIdx || 0, licenseKey);
    window.JREDD.setLicense  = (licenseKey) => {
      const i = LICENSES.findIndex(l => l.key === licenseKey);
      if (i >= 0) { activeLicense = i; renderLicensing(); updateCartPrice(); updateBuyTriggerPrice(); }
    };
    window.JREDD.openCart    = () => openCart();
    window.JREDD.play        = () => setPlaying(true);
    window.JREDD.LICENSES    = LICENSES;
    window.JREDD.getBeats    = () => BEATS;
    // v4.8: reusable, idempotent reconciliation hook (SPA-style navigation or
    // any code that mutates the Shopify cart out-of-band can call this).
    window.JREDD.reconcileCartState = reconcileCartState;
    document.dispatchEvent(new CustomEvent('jredd:ready'));
